import React from 'react';
import { Animated, Pressable, TouchableOpacity, StyleSheet, View, Text, Dimensions, Switch, StyleProp, TextStyle, Settings, Platform, } from 'react-native';
import { Feather, FontAwesome, FontAwesome5, Foundation, Ionicons, MaterialCommunityIcons, MaterialIcons, } from '@expo/vector-icons';
import {Connection, ConnectionOrd, ConnectionMkt, ISettings, IIndicator, ConnectionHis, } from '../~Utilities/Connection';
import {PriceType, TransactionType} from '../~Utilities/Rq';
import {AccData, Data, OrdDefault, PosData} from '../~Utilities/Data';
import Modal from "react-native-modal";
import RNPickerSelect from "react-native-picker-select";
import Utilities from '../~Utilities/Utilities';
import TextWithImage from '../C_Text/TextWithImage';
import Text3Eqv from '../C_Text/Text3Eqv';
import ModalEx from './ModalEx';
import DotsOrder from '../C_General/DotsOrder';
import { AppMain, FontInfo, IndicatorInfo, IPeriodInfo } from '../~Utilities/Constants';
import LED from '../C_Text/LED';
import { ScrollView } from 'react-native-gesture-handler';
import SwitchNE from '../C_Text/SwitchNoError';

/*   ------------------------------------------------------------------------   */

const DEFAULT_OPACITY   = 0.4;
const DEF_WIDTH         = 300;

// const AnimatedPressable = Animated.createAnimatedComponent(Pressable);
// const deviceWidth       = Dimensions.get("window").width;
// const deviceHeight      = Dimensions.get("window").height;

/*   ------------------------------------------------------------------------   */

// function IsLoggedIn() : boolean
// {
// if (ConnectionOrd.bSettingsLocal == true)
//   {
//   if (ConnectionMkt.oConn)
//     return(ConnectionMkt.oConn?.GetLoginStatus());
//   else
//     return(false);
//   }

// if (ConnectionOrd.oConn)
//   return(ConnectionOrd.oConn?.GetLoginStatus());
// else
//   return(false);
// }

/*   ------------------------------------------------------------------------   */

interface OrderState
  {
  visible            : boolean,
  buy_conf           : boolean,
  buy_conf_org       : boolean,
  sell_conf          : boolean,
  sell_conf_org      : boolean,

  // conf_visible       : boolean,
  // sym_prop_visible   : boolean,
  confirm_actions    : boolean,
  display_type       : number;
  display_txt        : string;
  display_txt_style? : StyleProp<TextStyle>;

  pnl_type           : number;
  wo_type            : number;

  pos_data?          : PosData,
  //acc_data?          : AccData,
  qty                : number,
  def_qty            : number,
  def_qty_evt        : number,
  evt                : boolean,

  book_levels        : number;

  cancel_all_enabled : boolean,
  flatten_enabled    : boolean,
  reverse_enabled    : boolean,
  price_type         : number;
  price?             : number;
  AnimOp             : Animated.Value;

  order_page         : number;

  def_order?         : OrdDefault;
  curr_order         : OrdDefault;

  //cancel_at_type     : number = Order.type;
  cancel_at_err?     : boolean;

  window_name?       : string;

  // cancel_after_en?   : boolean;
  // cancel_after_sec   : number;

  // cancel_at_en?      : boolean;
  // cancel_at_hr       : number;
  // cancel_at_min      : number;
  // cancel_at_sec      : number;
  // cancel_at_type     : number;
  // cancel_at_err?     : boolean;

  // bracket_target_en? : boolean;
  // bracket_target_tks : number;
  // bracket_stop_en?   : boolean;
  // bracket_stop_tks   : number;

  // bracket_stop_trl?  : boolean;

  // candles?              : boolean;
  // indicators            : boolean[];
  // indicator?            : number;
  // period_index          : number;
  }

/*   ------------------------------------------------------------------------   */

/*   ------------------------------------------------------------------------   */

const B_BIG   = 50;//60;
const B_SMALL = 40;//50;

const B_SETT_BIG    = 40;
const B_SETT_SMALL  = 30;

const B_BIG_PRICE   = 50;
const B_SMALL_PRICE = 40;

/*   ------------------------------------------------------------------------   */

export interface IOrder
{
  oData           : Data;
  iSettIndex      : number;
  onSelectAccount : (oData : PosData) => void;

  bindEvent       : (onEvent    : (() => void),
                     bSubscribe : boolean) => void
}

/*   ====================================================================   */

export default class Order extends React.Component<IOrder>
 {
  public static readonly DISPLAY_TRADE_BAR      = 1;
  public static readonly DISPLAY_TRADE_BAR_CONF = 2;
  public static readonly DISPLAY_SYMBOL_PROPS   = 3;
  public static readonly DISPLAY_SETTINGS       = 4;
  public static readonly DISPLAY_CHART_INFO     = 5;
  public static readonly DISPLAY_NO_ORDER       = 6;
  public static readonly DISPLAY_CXT_STATUS     = 7;

  public static readonly PNL_AUTO               = 0;
  public static readonly PNL_OPEN               = 1;
  public static readonly PNL_TOTAL              = 2;
  public static readonly PNL_OFF                = 3;

  public static readonly WO_COUNT               = 0;
  public static readonly WO_QTY                 = 1;

  public static readonly MSG_CHANGE_CONFIRM     = 1;
  public static readonly MSG_CHANGE_OB_LEVELS   = 2;

  // public static readonly MSG_CHANGE_CANDLES     = 3;
  // public static readonly MSG_CHANGE_INDICATOR   = 4;
  // public static readonly MSG_CHANGE_PERIOD      = 5;

  /*   -------------------------------------------------------------------   */

  public static readonly PAGE_ORDER             = 0;
  public static readonly PAGE_OPTIONS           = 1;
  public static readonly PAGE_BRACKET           = 2;

  /*   -------------------------------------------------------------------   */

  public static readonly REL_HR                 = 0;
  public static readonly REL_MIN                = 1;
  public static readonly REL_SEC                = 2;

  /*   -------------------------------------------------------------------   */

  private onConfirmApply : Array<(  (iMsg:number, oData:any) => void  )> = [  ];

  /*   -------------------------------------------------------------------   */

  iPriceType  = PriceType.MARKET;

  private oAccData?   : AccData;
  // private sSvAccount? : string;

  //oPriceTypes = Order.GetPriceTypes();

  /*   -------------------------------------------------------------------   */

  // iDeviceWidth  = 0;
  // iDeviceHeight = 0;

   /*   -------------------------------------------------------------------   */

  scrollRef                         : ScrollView | null = null;
  dotRef                            : DotsOrder | null  = null;
  curr_order_page                   : number  = Order.PAGE_ORDER;
  curr_sett_page                    : number  = Order.PAGE_ORDER;
  cancelAtTime?                     : number;
  // is_loaded                         : boolean = false;

  /*   -------------------------------------------------------------------   */

   Refresh()
   {
     //alert("refreshing...");
     this.forceUpdate();
   }

  /*   -------------------------------------------------------------------   */

  ApplySettings(onApply : (iMsg: number, oData: any)=>void, 
                           bSubscribe: boolean)
  {
  if (bSubscribe)
    this.onConfirmApply.push(onApply);
  else
    {
    var iZ = this.FindValueEvent(onApply);

    if (iZ != -1)
      this.onConfirmApply.splice(iZ, 1);
    }
  }

  /*   -------------------------------------------------------------------   */

  FindValueEvent(oEvent)
  {
  for (let i = 0; i < this.onConfirmApply.length; i++)
    if (this.onConfirmApply[i] == oEvent)
      return(i);

  return(AppMain.IMAGINARY);
  }

  /*   -------------------------------------------------------------------   */

  GetData(sAccKey : string = "")
  {
    if (Connection.oAccStore.size > 0)
      {
      let acckey : string;

      if (sAccKey && Connection.oAccStore.has(sAccKey))
        acckey = sAccKey;
      else
        acckey = Connection.oAccStore.keys().next().value;
      
      // let acckey = sAccKey;

      // if (!acckey)
      //   acckey = Connection.oAccStore.keys().next().value;

      let token   = "";

      if (this.props.oData.trading_symbol && this.props.oData.trading_exchange)
        token = this.props.oData.trading_symbol + "." + this.props.oData.trading_exchange;
      else
        token = this.props.oData.token;

      let key = acckey + token;

      //alert(key);

       let data1 = Connection.oPosStore.get(key);

       if (data1 == undefined)
        {
        //Utilities.Sendlog("New Pos: " + acckey + " token: " + token);

        data1 = new PosData(acckey, token);
        Connection.oPosStore.set(key, data1);
        }

       //alert(key + data1?.net_qty);

       this.props.onSelectAccount(data1);

       this.oAccData = Connection.oAccStore.get(acckey);

       return(data1);
      }
    // else
    //   Utilities.Sendlog("account size is 0");
  }

  /*   -------------------------------------------------------------------   */

  // readonly getIndicatorSettings = () =>
  // {
  // let oInds : IIndicator[];

  // for (let i = 0; i < this.state.indicators.length; i++)
  //   {

  //   }
  // }

  /*   -------------------------------------------------------------------   */

  HideModal()
  {
  // this.iPriceType = PriceType.MARKET;
  ModalEx.oModalEx?.Hide();

  this.setState({
                //  conf_visible       : false,
                //  sym_prop_visible   : false,
                 display_type:Order.DISPLAY_TRADE_BAR,

                 cancel_all_enabled : !this.state.confirm_actions,
                 flatten_enabled    : !this.state.confirm_actions,
                 reverse_enabled    : !this.state.confirm_actions,
                //  price_type         : PriceType.MARKET,
                 price              : undefined
                 });
  //this.SlideOut();

  /*   -------------------------------------------------------------------   */

  if (this.state.display_type == Order.DISPLAY_CHART_INFO)
    {
    // ConnectionOrd.SaveSettingsSymbol({token: this.props.oData.token, 
    //                                   oChartSettings:{bCandles:this.state.candles,
    //                                                   oIndicators:ConnectionOrd.
    //                                                   GetIndicatorList(this.state.indicator,
    //                                                                    this.state.period_index)}});
    }
  else if (this.state.display_type == Order.DISPLAY_TRADE_BAR_CONF)
    {
    ConnectionOrd.SaveSettingsSymbol({token: this.props.oData.token, 
                                      sAccount: this.state.pos_data?.acc_key,
                                      oOrdCurrent: this.oCurrOrder? 
                                      ConnectionOrd.CopyOrdCurrent(this.oCurrOrder, 
                                                                   new OrdDefault()) 
                                      : undefined});
    }
  else if (this.state.display_type == Order.DISPLAY_SETTINGS)
    {
    this.curr_sett_page = this.curr_order_page;

    ConnectionOrd.SaveSettingsSymbol({token: this.props.oData.token, 
                                      sAccount: this.state.pos_data?.acc_key,
                                      iPnlType: this.state.pnl_type,
                                      iWOType: this.state.wo_type,
                                      bConfActions: this.state.confirm_actions,
                                      iDefQty: this.state.def_qty,
                                      iDefQtyEvt: this.state.def_qty_evt,
                                      iOBLevels: this.state.book_levels,
                                      oOrdDefaults: this.oDefOrder? 
                                      ConnectionOrd.CopyOrdDefault(this.oDefOrder, 
                                                                   new OrdDefault()) 
                                      : undefined});

    if (this.state.book_levels != this.props.oData.book_levels)
      {
      for (let i = 0; i < this.onConfirmApply.length; i++)
        {
        this.onConfirmApply[i](Order.MSG_CHANGE_OB_LEVELS, this.state.book_levels);
        }
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  Increment(delta : number = 1)
  {
  this.setState({qty:this.state.qty + delta});
  //alert(this.state.qty);
  }

  /*   -------------------------------------------------------------------   */

  IncrementLevels(delta : number = 50)
  {
  let iLevels = this.state.book_levels + delta;

  if (iLevels > 1000)
    iLevels = 1000;

  //if (this.state.book_levels + delta <= 1000)
    // this.setState({book_levels:this.state.book_levels + delta});

  if (this.state.book_levels != iLevels)
    this.setState({book_levels: iLevels});
  //alert(this.state.qty);
  }

  /*   -------------------------------------------------------------------   */

  IncrementCancelAfter(delta : number,
                       def   : boolean = false)
  {
  let iVal;

  if (!def)
    {
    if (this.state.curr_order.cancel_after_sec + delta <= 0)
      iVal = 1;
      //this.setState({cancel_after_sec:1});
    else
      iVal = this.state.curr_order.cancel_after_sec + delta;

    this.oCurrOrder.cancel_after_sec = iVal;
    this.setState({curr_order: this.oCurrOrder});
    }
  else
    {
    if (!this.state.def_order || !this.oDefOrder) return;

    if (this.state.def_order.cancel_after_sec + delta <= 0)
      iVal = 1;
      //this.setState({cancel_after_sec:1});
    else
      iVal = this.state.def_order.cancel_after_sec + delta;

    this.oDefOrder.cancel_after_sec = iVal;
    this.setState({def_order: this.oDefOrder});      
    }
  
    //this.setState({cancel_after_sec:this.state.curr_order.cancel_after_sec + delta});
  }

  /*   -------------------------------------------------------------------   */

  IncrementTargetTks(delta : number,
                     def   : boolean = false)
  {
  let iVal;

  if (!def)
    {
    if (this.state.curr_order.bracket_target_tks + delta <= 0)
      iVal = 1;
      //this.setState({bracket_target_tks:1});
    else
      iVal = this.state.curr_order.bracket_target_tks + delta;

    this.oCurrOrder.bracket_target_tks = iVal;
    this.setState({curr_order: this.oCurrOrder});
    }
  else
    {
    if (!this.state.def_order || !this.oDefOrder) return;

    if (this.state.def_order.bracket_target_tks + delta <= 0)
      iVal = 1;
      //this.setState({bracket_target_tks:1});
    else
      iVal = this.state.def_order.bracket_target_tks + delta;

    this.oDefOrder.bracket_target_tks = iVal;
    this.setState({def_order: this.oDefOrder});      
    }
  
    //this.setState({bracket_target_tks:this.state.curr_order.bracket_target_tks + delta});
  }

  /*   -------------------------------------------------------------------   */

  IncrementStopTks(delta : number,
                   def   : boolean = false)
  {
  let iVal;

  if (!def)
    {
    if (this.state.curr_order.bracket_stop_tks + delta <= 0)
      //this.setState({bracket_stop_tks:1});
      iVal = 1;
    else
      iVal = this.state.curr_order.bracket_stop_tks + delta;

    this.oCurrOrder.bracket_stop_tks = iVal;
    this.setState({curr_order: this.oCurrOrder});
    }
  else
    {
    if (!this.state.def_order || !this.oDefOrder) return;

    if (this.state.def_order.bracket_stop_tks + delta <= 0)
      //this.setState({bracket_stop_tks:1});
      iVal = 1;
    else
      iVal = this.state.def_order.bracket_stop_tks + delta;

    this.oDefOrder.bracket_stop_tks = iVal;
    this.setState({def_order: this.oDefOrder});      
    }
 
    //this.setState({bracket_stop_tks:this.state.curr_order.bracket_stop_tks + delta});
  }

  /*   -------------------------------------------------------------------   */

  IncrementTimeAt(delta : number,
                  def   : boolean = false)
  {
  switch(!def? this.state.curr_order.cancel_at_type : 
               this.state.def_order?.cancel_at_type)
    {
    case Order.REL_HR:
      this.IncrementTimeAt_Hr(delta, def);
      break;

    case Order.REL_MIN:
      this.IncrementTimeAt_Min(delta, def);
      break;
        
    case Order.REL_SEC:
      this.IncrementTimeAt_Sec(delta, def);
      break;        
    }
  }

  /*   -------------------------------------------------------------------   */

  IncrementTimeAt_Hr(delta : number,
                     def   : boolean = false)
  {
  if (!def)
    {
    let iVal = this.state.curr_order.cancel_at_hr + delta;

    if (iVal < 0)
      iVal = 23;
    else if (iVal > 23)
      iVal = 0;


    this.oCurrOrder.cancel_at_hr  = iVal;
    //this.oCurrOrder.cancel_at_err = false;
    this.setState({curr_order: this.oCurrOrder, cancel_at_err:false});
    }
  else
    {
    if (!this.state.def_order || !this.oDefOrder) return;

    let iVal = this.state.def_order.cancel_at_hr + delta;

    if (iVal < 0)
      iVal = 23;
    else if (iVal > 23)
      iVal = 0;


    this.oDefOrder.cancel_at_hr  = iVal;
    //this.oDefOrder.cancel_at_err = false;
    this.setState({def_order: this.oDefOrder, cancel_at_err:false});
    }

  //this.setState({cancel_at_hr: iVal, cancel_at_err:false});
  }

  /*   -------------------------------------------------------------------   */

  IncrementTimeAt_Min(delta : number,
                      def   : boolean = false)
  {
  if (!def)
    {
    let iVal = this.state.curr_order.cancel_at_min + delta;

    if (iVal < 0)
      iVal = 59;
    else if (iVal > 59)
      iVal = 0;


    this.oCurrOrder.cancel_at_min = iVal;
    //this.oCurrOrder.cancel_at_err = false;
    this.setState({curr_order: this.oCurrOrder, cancel_at_err:false});
    }
  else
    {
    if (!this.state.def_order || !this.oDefOrder) return;  

    let iVal = this.state.def_order.cancel_at_min + delta;

    if (iVal < 0)
      iVal = 59;
    else if (iVal > 59)
      iVal = 0;


    this.oDefOrder.cancel_at_min = iVal;
    //this.oDefOrder.cancel_at_err = false;
    this.setState({def_order: this.oDefOrder, cancel_at_err:false});
    }

  //this.setState({cancel_at_min: iVal, cancel_at_err:false});
  }

  /*   -------------------------------------------------------------------   */

  IncrementTimeAt_Sec(delta : number,
                      def   : boolean = false)
  {
  if (!def)
    {
    let iVal = this.state.curr_order.cancel_at_sec + delta;

    if (iVal < 0)
      iVal = 59;
    else if (iVal > 59)
      iVal = 0;


    this.oCurrOrder.cancel_at_sec = iVal;
    //this.oCurrOrder.cancel_at_err = false;
    this.setState({curr_order: this.oCurrOrder, cancel_at_err:false});
    }
  else
    {
    if (!this.state.def_order || !this.oDefOrder) return;  

    let iVal = this.state.def_order.cancel_at_sec + delta;

    if (iVal < 0)
      iVal = 59;
    else if (iVal > 59)
      iVal = 0;


    this.oDefOrder.cancel_at_sec = iVal;
    //this.oDefOrder.cancel_at_err = false;
    this.setState({def_order: this.oDefOrder, cancel_at_err:false});
    }

  //this.setState({cancel_at_sec: iVal, cancel_at_err:false});
  }

  /*   -------------------------------------------------------------------   */

  IncrementDef(delta : number = 1)
  {
  if (this.state.evt)
    this.setState({def_qty_evt:this.state.def_qty_evt + delta});
  else
    this.setState({def_qty:this.state.def_qty + delta});

  //alert(this.state.qty);
  }

  /*   -------------------------------------------------------------------   */

  IncrementPrice(delta : number = 1)
  {
  if (this.state.price)
    {
    let dPrice = Utilities.round(this.state.price + (delta * this.props.oData.qpc),
                                 this.props.oData.f2qp);

    this.setState({price:dPrice});
    }
  }

  /*   -------------------------------------------------------------------   */

  Decrement(delta : number = 1)
  {
    //alert("decrement");
  //if (this.state.qty > 1)
    let newqty = this.state.qty - delta;

    if (newqty < 1)
      newqty = 1;

    this.setState({qty:newqty});
  }

  /*   -------------------------------------------------------------------   */

  DecrementLevels(delta : number = 50)
  {
  let iLevels = this.state.book_levels - delta;

  if (iLevels < 100)
    iLevels = 100;

  if (this.state.book_levels != iLevels)    
    this.setState({book_levels: iLevels});
    
  // if (this.state.book_levels - delta >= 100)    
  //   this.setState({book_levels:this.state.book_levels - delta});
  //alert(this.state.qty);
  }

  /*   -------------------------------------------------------------------   */

  DecrementDef(delta : number = 1)
  {
    //alert("decrement");
  //if (this.state.qty > 1)

  if (this.state.evt)
    {
    let newqty = this.state.def_qty_evt - delta;

    if (newqty < 1)
      newqty = 1;

    this.setState({def_qty_evt:newqty});
    }
  else
    {
    let newqty = this.state.def_qty - delta;

    if (newqty < 1)
      newqty = 1;

    this.setState({def_qty:newqty});
    }
  }

  /*   -------------------------------------------------------------------   */

  shouldComponentUpdate()
  {
  // this.iDeviceWidth  = Dimensions.get("window").width;
  // this.iDeviceHeight = Dimensions.get("window").height;

  return(true);
  }

  /*   -------------------------------------------------------------------   */

  DecrementPrice(delta : number = 1)
  {
    //Utilities.Sendlog("decrementing...");

  if (this.state.price)
    {
    let dPrice = Utilities.round(this.state.price - (delta * this.props.oData.qpc),
                                this.props.oData.f2qp);

    //Utilities.Sendlog("new price: " + dPrice);

    this.setState({price:dPrice});
    }
  //else
  //  Utilities.Sendlog("no price...");

    //this.setState({price:this.state.price - (delta * this.props.oData.qpc)});
  }

  /*   -------------------------------------------------------------------   */

  GetAPrice()
  {
  //Utilities.Sendlog(this.state.price + " " + this.props.oData.bid + " " + this.props.oData.ask + " " + this.props.oData.last);

  if (this.state.price == undefined)
    {
    if (this.state.buy_conf)
      {
      if (this.props.oData.bid != undefined)
        return(this.props.oData.bid);
      else if (this.props.oData.ask != undefined)
        return(this.props.oData.ask);
      else
        return(this.props.oData.last);
      }
    else
      {
      if (this.props.oData.ask != undefined)
        return(this.props.oData.ask);
      else if (this.props.oData.bid != undefined)
        return(this.props.oData.bid);
      else
        return(this.props.oData.last);
      }
    }
  else
    return(this.state.price);
  }

  /*   -------------------------------------------------------------------   */

  // SetPriceType(iPriceType : number,
  //              dPrice     : number | undefined)
  // {
  // this.iPriceType = iPriceType;

  // this.setState({price_type:iPriceType, price:dPrice});
  // }

  /*   -------------------------------------------------------------------   */

  CancelAll()
  {
  // if (Connection.IsOrderAvailable() == false)
  //   {
  //   this.ShowNoOrder();  
  //   return;
  //   }

  if (this.state.cancel_all_enabled == false && this.state.confirm_actions)
    {
    this.setState({reverse_enabled:false, cancel_all_enabled:true, flatten_enabled:false});
    }
  else
    {
    if (this.state.pos_data && this.state.pos_data?.orders_working.length > 0)
      {
      ConnectionOrd.oConn?.Rq_CancelAllOrders(this.state.pos_data, 
                                              "Window Menu, Cancel All Button");
      }

    this.HideModal();
    }
  }

  /*   -------------------------------------------------------------------   */

  Flatten()
  {
  if (Connection.IsOrderAvailable() == false)
    {
    this.ShowNoOrder();  
    return;
    }

  if (this.state.flatten_enabled == false && this.state.confirm_actions)
    {
      this.setState({reverse_enabled:false, cancel_all_enabled:false, flatten_enabled:true})
    }
  else
    {
    if (this.state.pos_data && this.state.pos_data?.orders_working.length > 0)
      {
      ConnectionOrd.oConn?.Rq_CancelAllOrders(this.state.pos_data, 
                                              "Window Menu, Cncl All & Fltn Button");
      }

    /* if (this.state.pos_data        &&
        this.state.pos_data?.net_qty &&
        this.state.pos_data?.net_qty != 0)
      {
      ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                         this.props.oData.token,
                                         this.state.pos_data?.net_qty < 0?
                                         TransactionType.BUY : TransactionType.SELL,
                                         Math.abs(this.state.pos_data?.net_qty))
      } */

    if (this.state.pos_data)
      {
      ConnectionOrd.oConn?.Rq_ExitPosition(this.state.pos_data?.acc_key,
                                           this.props.oData.token,
                                           "Window Menu, Cncl All & Fltn Button");
      }

    this.HideModal();
    }
  }

  /*   -------------------------------------------------------------------   */

  Reverse()
  {
  if (Connection.IsOrderAvailable() == false)
    {
    this.ShowNoOrder();  
    return;
    }

  if (this.state.reverse_enabled == false && this.state.confirm_actions)
    {
      this.setState({reverse_enabled:true, cancel_all_enabled:false, flatten_enabled:false})
    }
  else
    {
    if (this.state.pos_data        &&
        this.state.pos_data?.net_qty &&
        this.state.pos_data?.net_qty != 0)
      {
      ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                         this.props.oData.token,
                                         this.state.pos_data?.net_qty < 0?
                                         TransactionType.BUY : TransactionType.SELL,
                                         Math.abs(2 * this.state.pos_data?.net_qty),
                                         "Window Menu, Reverse Pos Button")
      }

    this.HideModal();
    }
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount()
  {
  this.props.bindEvent(this.UpdateData, true);

  // this.is_loaded = true;

  //alert();
  //  if (this.state.display_type == Order.DISPLAY_TRADE_BAR_CONF)
  //    {
  //     this.scrollRef?.scrollTo({x:this.state.order_page * DEF_WIDTH, animated: false})      
  //    //this.scrollRef?.scrollTo({x: DEF_WIDTH, animated:false});
  //    }


  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount()
  {
  this.props.bindEvent(this.UpdateData, false);

  this.onConfirmApply.splice(0, this.onConfirmApply.length);
  }

  /*   ------------------------------------------------------------------   */

  UpdateData()
  {
  if (Connection.oAccStore.size > 0 &&
      this.state.pos_data       == undefined)
    {
    this.setState({pos_data: this.GetData(this.props.oData.sv_account)}); //this.GetData()});
    }
  }

  /*   ------------------------------------------------------------------   */

  GetAccounts()
  {
    let oAccs = new Array(0);

    for (let [key, value] of Connection.oAccStore.entries())
      {
      oAccs.push({label:value.acc_id, value:key, key:key, color:"black"});

      //Utilities.Sendlog("adding key: " + key);
      }

    // if (!this.state.pos_data)
    //   {
    //   let oPosData = this.GetData();

    //   if (oPosData != undefined)
    //     this.setState({pos_data:oPosData});

    //   Utilities.Sendlog("acc key: " + oPosData?.acc_key + " size: " + oAccs.length);
    //   }

    //if (oAccs.length == 0)
    //  oAccs.push({label:"21", value:"2", key:"2"});

    return(oAccs);
  }

  /*   -------------------------------------------------------------------   */

  GetPriceTypes()
  {
    let oPriceTypes = new Array(0);

    oPriceTypes.push({label:"Market", value:PriceType.MARKET.toString(), key:PriceType.MARKET.toString() });
    oPriceTypes.push({label:"Limit", value:PriceType.LIMIT.toString(), key:PriceType.LIMIT.toString()});
    oPriceTypes.push({label:"Stop Market", value:PriceType.STOP_MARKET.toString(), key:PriceType.STOP_MARKET.toString()});
    oPriceTypes.push({label:"Stop Limit", value:PriceType.STOP_LIMIT.toString(), key:PriceType.STOP_LIMIT.toString()});

    return(oPriceTypes);
  }

  /*   -------------------------------------------------------------------   */

  renderAccBalance_old()
  {
  if (this.oAccData?.acc_balance && Connection.IsOrderAvailable())
    return(
      <View style={{flexDirection:'column', marginBottom:5, marginTop:10, alignItems:'center'}}>

      <View style={{flexDirection:'row', marginBottom:5,}}>

      <View style={{flexDirection:'column', alignContent:'center', marginRight:20, alignItems:'center'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Account Balance</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.oAccData?.acc_balance)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  }}
                getText={()=>
                  {
                  if (this.oAccData?.acc_balance) 
                    return(this.oAccData?.acc_balance.toString());
                  }} />

      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginTop:10}]}>Open P&L</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.open_pnl && this.state.pos_data?.open_pnl >= 0)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  else
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:'red'}])
                  }}
                getText={()=>{return(this.state.pos_data?.open_pnl)}} />

      </View>

      <View style={{flexDirection:'column', alignContent:'center', alignItems:'center'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Avg Open Fill Price</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.avg_open_fillprice)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:'#F2B302'}])
                  }}
                getText={()=>
                  {
                    if (this.state.pos_data?.net_qty && this.state.pos_data?.avg_open_fillprice)
                      return(this.state.pos_data?.avg_open_fillprice.toFixed(this.props.oData.f2qp + 2));
                  }} />

      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginTop:10}]}>Total P&L</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.total_pnl && this.state.pos_data?.total_pnl >= 0)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  else
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:'red'}])
                  }}
                getText={()=>{return(this.state.pos_data?.total_pnl)}} />

      </View>
      </View>


      {/* <View style={{flexDirection:'row', marginBottom:5,}}>    
      <View style={{flexDirection:'column', alignContent:'center', marginRight:20}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Open P&L</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.open_pnl)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  }}
                getText={()=>{return(this.state.pos_data?.open_pnl)}} />
      </View>

      <View style={{flexDirection:'column', alignContent:'center', marginRight:20}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Total P&L</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.total_pnl)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  }}
                getText={()=>{return(this.state.pos_data?.total_pnl)}} />
      </View>
      </View> */}


      </View>
    );
  else return(
    <View style={{flexDirection:'row', marginBottom:5,}}>
    <Text style={[FontInfo.appStyles.txt_bold, {color:'red', fontSize: FontInfo.iFontSize + 2, }]}>Trading not available</Text> 
    </View>
  ); 
  }

  /*   -------------------------------------------------------------------   */

  renderAccBalance()
  {
  if (this.oAccData?.acc_balance && Connection.IsOrderAvailable())
    return(
      <View style={{flexDirection:'column', marginBottom:5, marginTop:10, alignItems:'center', backgroundColor:'transparent'}}>

      <View style={{flexDirection:'row', marginBottom:5,}}>

      <View style={{flexDirection:'column', alignContent:'center', marginRight:20, alignItems:'center'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Account Balance</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.oAccData?.acc_balance)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  }}
                getText={()=>
                  {
                  if (this.oAccData?.acc_balance) 
                    return(this.oAccData?.acc_balance.toString());
                  }} />

      {/* <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginTop:10}]}>Open P&L</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.open_pnl && this.state.pos_data?.open_pnl >= 0)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  else
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:'red'}])
                  }}
                getText={()=>{return(this.state.pos_data?.open_pnl)}} /> */}

      </View>

      <View style={{flexDirection:'column', alignContent:'center', alignItems:'center'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Avg Open Fill Price</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.avg_open_fillprice)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sLightBlue}])
                  }}
                getText={()=>
                  {
                    if (this.state.pos_data?.net_qty && this.state.pos_data?.avg_open_fillprice)
                      return(this.state.pos_data?.avg_open_fillprice.toFixed(this.props.oData.f2qp + 2));
                  }} />

      {/* <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginTop:10}]}>Total P&L</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  if (this.state.pos_data?.total_pnl && this.state.pos_data?.total_pnl >= 0)
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:FontInfo.sGreen}])
                  else
                    return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color:'red'}])
                  }}
                getText={()=>{return(this.state.pos_data?.total_pnl)}} />
 */}
      </View>
      </View>



      <View style={{flexDirection:'column', alignItems:'center', alignContent:'center', backgroundColor:'transparent'}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>P&L</Text> 
      <Text3Eqv bindEvent={this.props.bindEvent} 
                getStyle={()=>
                  {
                  return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', color: this.GetPNLColor(true), }])
                  }}
                getText={this.GetPNLText} />
      </View>



      </View>
    );
  else return(
    <View style={{flexDirection:'row', marginBottom:5,}}>
    <Text style={[FontInfo.appStyles.txt_bold, {color:'red', fontSize: FontInfo.iFontSize + 2, }]}>Trading not available</Text> 
    </View>
  ); 
  }

  /*   -------------------------------------------------------------------   */

  renderSymbolProps()
  {
    // if (this.state.display_type!=Order.DISPLAY_SYMBOL_PROPS)
    //   return(null);
    // else
    return (
      <Modal style={{}}
        // deviceWidth={this.iDeviceWidth}
        // deviceHeight={this.iDeviceHeight}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        // animationInTiming={500}
        // animationOutTiming={250}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        // isVisible={this.state.sym_prop_visible}
        isVisible={this.state.display_type==Order.DISPLAY_SYMBOL_PROPS}
        onBackdropPress={()=>this.HideModal()}

        // customBackdrop={
        //   <TouchableWithoutFeedback  style={{backgroundColor:'black'}} onPress={()=>this.HideModal()}>
        //     <View style={{ flex: 1 }} />
        //   </TouchableWithoutFeedback>
        // }

        >

        {/* <View style={{alignItems:'center', justifyContent:'center', position: 'absolute', left:0, right:0, backgroundColor: 'red', top:0, bottom:0}}>
        </View> */}

        <View style={{alignSelf:'center', minWidth:300, flexDirection:'column', borderRadius:15}}>

        <View style={[styles.row_header_container, {}]}>
        <Text style={[FontInfo.appStyles.txt_bold, styles.row_header, {fontSize: FontInfo.iFontSize + 2,}]}>{this.state.pos_data?.token}</Text>
        </View>

        {/* <View style={{width:300, height:25, alignSelf:'center', alignItems:'center', backgroundColor:'rgba(0, 0, 0, .9)', borderTopRightRadius:15, borderTopLeftRadius:15, }} >
        <Text style={[FontInfo.appStyles.txt_bold, {paddingTop:4, color:'white', }]}>{this.state.pos_data?.token}</Text>
        </View> */}

        <View style={{alignSelf:'center', flexDirection:'column', alignItems:'center', justifyContent:'center', borderBottomStartRadius:15,
                      borderBottomEndRadius:15, minWidth:300, backgroundColor:FontInfo.sBackgroundTp, paddingBottom:10}}>

        {/* <View style={{position:'absolute', marginHorizontal:10, top:10, left:0, width:280, height:40, alignItems:'center', justifyContent:'center', backgroundColor:'yellow'}}> */}
         {/* <View style={{backgroundColor:'red'}}> */}

          <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, color:FontInfo.sForeground, fontSize: FontInfo.iFontSize + 2,}]}>{this.oAccData?.acc_id}</Text>
          {/* <RNPickerSelect
                 style={GetPickerStyles()}
                 onValueChange={(sValue, iIndex) => {  this.ChangeAccount(sValue); }}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={this.GetAccounts()}
                 value={this.state.pos_data?.acc_key}
             /> */}

          <this.renderAccBalance/>
          {/* <View style={!this.oAccData?.acc_balance? {flexDirection:'row', marginBottom:5,} : {display:'none'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:'red', fontSize: FontInfo.iFontSize + 2, }]}>Trading not available</Text> 
          </View>

          <View style={this.oAccData?.acc_balance? {flexDirection:'row', marginBottom:5,} : {display:'none'}}>

          <View style={{flexDirection:'column', alignContent:'flex-end', marginRight:20}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Account Balance</Text> 
          <Text3Eqv bindEvent={this.props.bindEvent} 
                    getStyle={()=>
                      {
                      if (this.oAccData?.acc_balance)
                        return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'right', color:FontInfo.sGreen}])
                      }}
                    getText={()=>
                      {
                      if (this.oAccData?.acc_balance) 
                        return(this.oAccData?.acc_balance.toString());
                      }} />
          </View>

          <View style={{flexDirection:'column', alignContent:'flex-end'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Avg Open Fill Price</Text> 
          <Text3Eqv bindEvent={this.props.bindEvent} 
                    getStyle={()=>
                      {
                      if (this.state.pos_data?.avg_open_fillprice)
                        return([FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'right', color:'#0247fe'}])
                      }}
                    getText={()=>
                      {
                        if (this.state.pos_data?.avg_open_fillprice)
                          return(this.state.pos_data?.avg_open_fillprice.toFixed(this.props.oData.f2qp + 2));
                      }} />
          </View>
          </View> */}

          </View>
          </View>
          {/* </View> */}

          {/* </View> */}

      <View style={{flexDirection:'row', alignSelf:'center'}}>

      <TouchableOpacity onPress={()=>{this.Reverse()}} style={this.state.reverse_enabled? 
        {opacity:1, justifyContent:'center', backgroundColor:FontInfo.sLightBlue, marginHorizontal:7, marginVertical:10, 
        padding:8, borderRadius:45, minWidth:90, minHeight:90} : 
        
        {opacity:1, justifyContent:'center', backgroundColor:FontInfo.sBackgroundTp, marginHorizontal:7, marginVertical:10, 
        padding:8, borderRadius:45, minWidth:90, minHeight:90, borderWidth:0, borderColor:FontInfo.sBorder}}>

        <Text style={this.state.reverse_enabled? 
        [FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', alignSelf:'center', color:'white',}] : 
        [FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', alignSelf:'center', color:FontInfo.sLightBlue,}]}>Reverse{'\n'}Position</Text>

        {/* <View style={{borderWidth:0, minWidth:50, alignSelf:'center', backgroundColor:'gainsboro', borderRadius:10,}}>
        <Text3 name = "" bbb={this.props.bindEvent}
              getstyle={()=>
                {
                  if (this.state.pos_data?.net_qty == undefined ||
                      this.state.pos_data?.net_qty == 0)
                    return([{fontSize:14, fontWeight:'bold', color: 'grey', textAlign:'center' }])
                  else if (this.state.pos_data?.net_qty > 0)
                    return([{fontSize:14, fontWeight:'bold', color: 'dodgerblue', textAlign:'center' }])
                  else
                    return([{fontSize:14, fontWeight:'bold', color: 'hotpink', textAlign:'center' }])
                }}
              ggg={()=>
                {
                  if (this.state.pos_data?.net_qty != undefined)
                    return(this.state.pos_data?.net_qty + "");
                  else
                    return("0");
                }}></Text3>
      </View> */}
      </TouchableOpacity>

      <TouchableOpacity onPress={()=>{this.CancelAll()}} style={this.state.cancel_all_enabled? 
         {opacity:1, justifyContent:'center', backgroundColor:'darkorange', marginHorizontal:7, marginVertical:10, 
         padding:8, borderRadius:45, minWidth:90, minHeight:90} : 
         
         {opacity:1, justifyContent:'center', backgroundColor:FontInfo.sBackgroundTp, marginHorizontal:7, marginVertical:10, 
         padding:8, borderRadius:45, minWidth:90, minHeight:90, borderWidth:0, borderColor:FontInfo.sBorder}}>

          <Text style={this.state.cancel_all_enabled? 
           [FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', alignSelf:'center', color:'white', }] : 
           [FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', alignSelf:'center', color:'darkorange', }]}>Cancel{'\n'}All</Text>

          {/* <Text style={this.state.cancel_all_enabled? {alignSelf:'center', fontWeight:'bold', color:'white', } : {alignSelf:'center', fontWeight:'bold', color:'#b0bf1a', }}> {this.state.pos_data?.orders.length} </Text> */}

          {/* <View style={{borderWidth:0, minWidth:50, alignSelf:'center', backgroundColor:'gainsboro', borderRadius:10,}}>
          <Text3 name = "" bbb={this.props.bindEvent}
                getstyle={()=>
                  {
                    if (this.state.pos_data                        == undefined ||
                        this.state.pos_data?.orders_working.length == 0)
                      return([{fontSize:14, fontWeight:'bold', color: 'grey', textAlign:'center' }])
                    else
                      return([{fontSize:14, fontWeight:'bold', color: 'green', textAlign:'center' }])
                  }}
                ggg={()=>
                  {
                    if (this.state.pos_data != undefined)
                      return(this.state.pos_data?.orders_working.length + "");
                    else
                      return("0");
                  }}></Text3>
        </View> */}

      </TouchableOpacity>

      <TouchableOpacity onPress={()=>{this.Flatten()}} style={this.state.flatten_enabled? 
        {opacity:1, justifyContent:'center', backgroundColor:'#ef3038', 
         marginHorizontal:7, marginVertical:10, padding:8, borderRadius:45, minWidth:90, minHeight:90} : 

         {opacity:1, justifyContent:'center', backgroundColor:FontInfo.sBackgroundTp, marginHorizontal:7, marginVertical:10, 
         padding:8, borderRadius:45, minWidth:90, minHeight:90, borderWidth:0, borderColor:FontInfo.sBorder}}>

        <Text style={this.state.flatten_enabled? 
        [FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', alignSelf:'center', color:'white',}] : 
        [FontInfo.appStyles.txt_bold, {fontSize: FontInfo.iFontSize + 2, textAlign:'center', alignSelf:'center', color:'#ef3038',}]}>Cncl All{'\n'}& Fltn</Text>

        {/* <View style={{borderWidth:0, minWidth:50, alignSelf:'center', backgroundColor:'gainsboro', borderRadius:10,}}>
        <Text3 name = "" bbb={this.props.bindEvent}
              getstyle={()=>
                {
                  if (this.state.pos_data?.net_qty == undefined ||
                      this.state.pos_data?.net_qty == 0)
                    return([{fontSize:14, fontWeight:'bold', color: 'grey', textAlign:'center' }])
                  else if (this.state.pos_data?.net_qty > 0)
                    return([{fontSize:14, fontWeight:'bold', color: 'dodgerblue', textAlign:'center' }])
                  else
                    return([{fontSize:14, fontWeight:'bold', color: 'hotpink', textAlign:'center' }])
                }}
              ggg={()=>
                {
                  if (this.state.pos_data?.net_qty != undefined)
                    return(this.state.pos_data?.net_qty + "");
                  else
                    return("0");
                }}></Text3>
      </View> */}
      </TouchableOpacity>

      <View style={(this.state.reverse_enabled || this.state.cancel_all_enabled || this.state.flatten_enabled) && this.state.confirm_actions?
                   {width:300, backgroundColor:'transparent', position:'absolute', bottom:-20, } : {display:'none'}}>
        <Text style={[FontInfo.appStyles.txt_normal, {alignSelf:'center', fontSize: FontInfo.iFontSize + 2, color:'white'}]}>Tap again to confirm</Text>
      </View>

      </View>

      {/* <View style={this.state.confirm_actions? {minHeight:20} : {display:'none'}}> */}
      {/* <Text style={this.state.reverse_enabled || this.state.cancel_all_enabled || this.state.flatten_enabled?
            {position:'absolute', bottom:0, alignSelf:'center', fontSize:14, color:'white'} : {display:'none'}}>Tap again to confirm</Text> */}
      {/* </View> */}

      </Modal>

      // <Pressable
      //       onPress={this.HideModal}
      //       style={this.state.modal_visible == false? {display:'none'} : {position: 'absolute', left:0, right:0, zIndex: 200, backgroundColor: 'black', opacity: 0.5, top:0, bottom:0}}
      // ></Pressable>

    );
  }

  /*   -------------------------------------------------------------------   */

  renderOptionsBasicDef()
  {
    // if (this.state.order_page != Order.PAGE_OPTIONS)
    //   return(null);

    return (

        <View style={{flexDirection:'column', alignItems:'center', width:300, }}>


          {/* Def Qty */}
          <View style={{alignItems:'center', marginTop:20, alignContent:'center', justifyContent:'center', backgroundColor:'transparent'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, letterSpacing:0, }]}>Qty</Text>

          <View style={{marginTop:-5, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementDef(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementDef()}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.evt? this.state.def_qty_evt : this.state.def_qty}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementDef()}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementDef(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>
          </View>

          <SwitchNE style={Platform.OS=='android'? {marginTop:10, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} : 
                                                 {marginTop:10, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
            trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
            ios_backgroundColor={FontInfo.sGrayTp}
            onValueChange={(value)=> 
              {
              if (!this.oDefOrder)
                return;

              this.oDefOrder.cancel_after_en = value;  
              this.setState({def_order: this.oDefOrder})
              }}
            value={this.state.def_order?.cancel_after_en}
          />

         <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Cancel After (Sec)</Text>


         <View style={{marginTop:-5, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(-10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(-1, true)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, 
                                            textAlign:'center', alignSelf:'center', }]}>{this.state.def_order?.cancel_after_sec}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(1, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color={FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>


          <SwitchNE style={Platform.OS=='android'? {marginTop:10, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} : 
                                                 {marginTop:10, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
            trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
            ios_backgroundColor={FontInfo.sGrayTp}
            onValueChange={(value)=> 
                {
                if (!this.oDefOrder)
                  return;

                this.oDefOrder.cancel_at_en  = value;  
                //this.oDefOrder.cancel_at_err = value? !this.validateOrder(false, true) : false;
                this.setState({def_order: this.oDefOrder});
                //this.setState({cancel_at_en: value, cancel_at_err: value? !this.validateOrder(false, true) : false})
                }}
            value={this.state.def_order?.cancel_at_en}
          />

         <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Cancel At</Text>


         <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>

         <View style={{marginTop:-5, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(-10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(-1, true)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>


            {/* Hr */}
            <TouchableOpacity style={{minHeight:30, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      backgroundColor: this.state.def_order?.cancel_at_type == Order.REL_HR? FontInfo.sLightGreen : 'transparent',  }}
              onPress={ ()=>
                { 
                if (!this.oDefOrder)
                  return; 
                    
                this.oDefOrder.cancel_at_type = Order.REL_HR;

                this.setState({def_order: this.oDefOrder}) 
                }}>
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.def_order?.cancel_at_type == Order.REL_HR? 'white' : FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{!this.state.def_order? "" : ((this.state.def_order.cancel_at_hr < 10? "0" : "") + this.state.def_order.cancel_at_hr) }</Text>
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, 
              marginHorizontal:-4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>:</Text>

            {/* Min */}
            <TouchableOpacity style={{minHeight:30, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      backgroundColor: this.state.def_order?.cancel_at_type == Order.REL_MIN? FontInfo.sLightGreen : 'transparent',  }}
              onPress={ ()=>
              { 
                if (!this.oDefOrder)
                  return; 
                    
                this.oDefOrder.cancel_at_type = Order.REL_MIN;

                this.setState({def_order: this.oDefOrder}) 
              } }>

            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.def_order?.cancel_at_type == Order.REL_MIN? 'white' : FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{!this.state.def_order? "" : ((this.state.def_order.cancel_at_min < 10? "0" : "") + this.state.def_order.cancel_at_min) }</Text>
            </TouchableOpacity>            

            {/* <TouchableOpacity style={{minHeight:30, borderWidth:1, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      borderColor: this.state.release_at_type == Order.REL_MIN? FontInfo.sBorder : 'transparent', backgroundColor:'transparent' }}
              onPress={ ()=>{ this.setState({release_at_type: Order.REL_MIN}) } }>
            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, backgroundColor:'transparent',
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{(this.state.release_at_min < 10? "0" : "") + this.state.release_at_min }</Text>
            </TouchableOpacity> */}

            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, 
              marginHorizontal:-4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>:</Text>

            {/* Sec */}
            <TouchableOpacity style={{minHeight:30, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      backgroundColor: this.state.def_order?.cancel_at_type == Order.REL_SEC? FontInfo.sLightGreen : 'transparent',  }}
              onPress={ ()=>
              { 
              if (!this.oDefOrder)
                return; 
                  
              this.oDefOrder.cancel_at_type = Order.REL_SEC;

              this.setState({def_order: this.oDefOrder}) 
              } }>            
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.def_order?.cancel_at_type == Order.REL_SEC? 'white' : FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{!this.state.def_order? "" : ((this.state.def_order.cancel_at_sec < 10? "0" : "") + this.state.def_order.cancel_at_sec) }</Text>
            </TouchableOpacity>            

            {/* <TouchableOpacity style={{minHeight:30, borderWidth:1, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      borderColor: this.state.release_at_type == Order.REL_SEC? FontInfo.sBorder : 'transparent', backgroundColor:'transparent' }}
              onPress={ ()=>{ this.setState({release_at_type: Order.REL_SEC}) } }>            
            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{ (this.state.release_at_sec < 10? "0" : "") + this.state.release_at_sec}</Text>
            </TouchableOpacity> */}

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(1, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>


         </View>

         {/* <Text style={!this.state.def_order?.cancel_at_err? {display:'none'} : 
                      [FontInfo.appStyles.txt_normal, {marginTop:10, marginBottom:15, fontSize: FontInfo.iFontSize, color:'red'}]}>Time in past</Text> */}


        </View>
    );
  }

  /*   -------------------------------------------------------------------   */

  renderBracketBasicDef()
  {
    // if (this.state.order_page != Order.PAGE_BRACKET)
    //   return(null);

    return (

        <View style={{flexDirection:'column', alignItems:'center', width:300, height:'100%'}}>


        <SwitchNE style={Platform.OS=='android'? {marginTop:20, marginLeft:8, paddingBottom:0, marginBottom:-10, backgroundColor:'transparent'} :
                                               {marginTop:20, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
          trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
          ios_backgroundColor={FontInfo.sGrayTp}
          onValueChange={(value)=> 
              {
                if (!this.oDefOrder) 
                  return; 

                this.oDefOrder.bracket_target_en = value;  
                this.setState({def_order: this.oDefOrder})
              }}
          value={this.state.def_order?.bracket_target_en}
        />

        <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Bracket Target (Ticks)</Text>

        <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(-10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(-1, true)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, 
                      textAlign:'center', alignSelf:'center', }]}>{this.state.def_order?.bracket_target_tks}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(1, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>


        <SwitchNE style={Platform.OS=='android'? {marginTop:10, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} : 
                                               {marginTop:10, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
          trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
          ios_backgroundColor={FontInfo.sGrayTp}
          onValueChange={(value)=> 
              {
              if (!this.oDefOrder) 
                return; 

              this.oDefOrder.bracket_stop_en = value;  
              this.setState({def_order: this.oDefOrder})
              }}
          value={this.state.def_order?.bracket_stop_en}
        />

        <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Bracket Stop (Ticks)</Text>

        <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(-10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(-1, true)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, 
                                  textAlign:'center', alignSelf:'center', }]}>{this.state.def_order?.bracket_stop_tks}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(1, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(10, true)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>

        <SwitchNE style={Platform.OS=='android'? {marginTop:10, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} : 
                                               {marginTop:10, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
          trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
          ios_backgroundColor={FontInfo.sGrayTp}
          onValueChange={(value)=> 
            {
            if (!this.oDefOrder) 
              return; 

            this.oDefOrder.bracket_stop_trl = value;  
            this.setState({def_order: this.oDefOrder})
            }}
            
          value={this.state.def_order?.bracket_stop_trl}
        />

        <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Bracket Stop Trailing</Text>


      {/* <View style={{height:20, backgroundColor:'yellow'}}></View> */}
       {/* <TouchableOpacity style={{position:'absolute', left:4, bottom:4, height:20, width:20}}>
       <MaterialCommunityIcons name="content-save-cog" size={24} color="black" />
       </TouchableOpacity>

       <TouchableOpacity style={{position:'absolute', right:4, bottom:4, height:20, width:20}}>
       <Ionicons name="checkmark-done-circle-sharp" size={24} color="green" />
       </TouchableOpacity>        */}
  
        <TouchableOpacity style={{position:'absolute', left:8, bottom:0,}}
        onPress={()=>{ 
          if (!this.oDefOrder) 
          return; 

          this.oDefOrder.bracket_stop_en   = false;
          this.oDefOrder.bracket_target_en = false;
          this.oDefOrder.bracket_stop_trl  = false;
          this.setState({def_order: this.oDefOrder})
          }}
        >
       <Ionicons name="checkmark-done-circle-outline" size={30} color={FontInfo.sDimGrayTp} />
       {/* <FontAwesome name="circle-o" size={30} color={FontInfo.sDimGrayTp} /> */}
       {/* <MaterialCommunityIcons name="checkbox-multiple-blank-circle-outline" size={26} color={FontInfo.sForegroundTp} /> */}
       {/* <FontAwesome name="toggle-off" size={30} color={FontInfo.sDimGrayTp} /> */}
       {/* <MaterialIcons name="check-box-outline-blank" size={26} color={FontInfo.sDimGrayTp} /> */}
       </TouchableOpacity>       

       <TouchableOpacity style={{position:'absolute', right:8, bottom:0,}}
       onPress={()=>{ 
              if (!this.oDefOrder) 
              return; 

              this.oDefOrder.bracket_stop_en   = true;
              this.oDefOrder.bracket_target_en = true;
              this.oDefOrder.bracket_stop_trl  = true;
              this.setState({def_order: this.oDefOrder})
              }}
        >
       <Ionicons name="checkmark-done-circle-sharp" size={30} color={FontInfo.sDimGrayTp} />
       {/* <FontAwesome name="check-circle-o" size={30} color={FontInfo.sDimGrayTp} /> */}
       {/* <MaterialCommunityIcons name="checkbox-multiple-marked-circle-outline" size={26} color={FontInfo.sForegroundTp} /> */}
       {/* <FontAwesome name="toggle-on" size={30} color={FontInfo.sDimGrayTp} /> */}
       {/* <MaterialIcons name="check-box" size={26} color={FontInfo.sDimGrayTp} /> */}
       </TouchableOpacity>       

        </View>
    );
  }

  /*   -------------------------------------------------------------------   */

  renderSettingsDef()
  {
    return (

      <View style={{backgroundColor:'transparent',
                    flexDirection:'column', 
                    width:300,
                    alignItems:'center', alignContent:'center', }}>


      <RNPickerSelect
                 style={GetPickerStyles()}
                 onValueChange={(sValue, iIndex) => {  this.ChangeAccount(sValue); /*iSystemIndex = iIndex; */ }}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={this.GetAccounts()}
                 //itemKey={this.state.pos_data?.acc_key}
                 value={this.state.pos_data?.acc_key}

                //  items={[
                //      { label: "Rithmic Paper Trading", value: "Rithmic Paper Trading" },
                //      { label: "Rithmic Paper Trading (beta)", value: "Rithmic Paper Trading (beta)" },
                //  ]}
             />

        {/* <View style={styles.row_header_container}>
        <Text style={styles.row_header}>{this.props.oData?.symbol}.{this.props.oData.exchange}</Text>
        </View> */}

        {/* <View style={{flexDirection:'row', height:25, backgroundColor:'black'}}>
        </View> */}

        {/* Confirm */}
        <View style={{flexDirection:'column', margin:10, backgroundColor:'transparent', }}>
          <Text style={[FontInfo.appStyles.txt_bold, {marginBottom:10, color:FontInfo.sForeground, }]}>Confirm Actions</Text>
          <SwitchNE style={Platform.OS=='android'? {alignSelf:'center', marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} :
                                                 {alignSelf:'center', marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
                  trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
                  ios_backgroundColor={FontInfo.sGrayTp}
                  onValueChange={(value : boolean)=>{ 
                                                    for (let i = 0; i < this.onConfirmApply.length; i++)
                                                      {
                                                      this.onConfirmApply[i](Order.MSG_CHANGE_CONFIRM, value);
                                                      }
                
                                                      // if (this.onConfirmApply) 
                                                      //   this.onConfirmApply(value); 


                                                      this.setState({confirm_actions:value}) }}
                  value={this.state.confirm_actions}
                />
          </View>

          {/* P&L */}
          <View style={{alignSelf:'center', flexDirection:'column', margin:10, marginTop:10, backgroundColor:'transparent', }}>

          <Text style={[FontInfo.appStyles.txt_bold, {alignSelf:'center', color:FontInfo.sForeground, }]}>P&L</Text>

          <View style={{backgroundColor:'transparent', flexDirection:'row'}}>
            <TouchableOpacity style={{borderRadius:5, 
                backgroundColor:this.state.pnl_type==Order.PNL_AUTO? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>{this.setState({pnl_type:Order.PNL_AUTO})}}> 
                <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Auto</Text>
             </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.pnl_type==Order.PNL_OPEN? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
             onPress={()=>{this.setState({pnl_type:Order.PNL_OPEN})}}> 

              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Open</Text>
            </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.pnl_type==Order.PNL_TOTAL? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}} //'rgba(152,251,152,.9)'
              onPress={()=>{this.setState({pnl_type:Order.PNL_TOTAL})}}> 
              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Total</Text>
            </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.pnl_type==Order.PNL_OFF? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>{this.setState({pnl_type:Order.PNL_OFF})}}> 
              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Off</Text>
            </TouchableOpacity>

          </View>
          </View>

          {/* Working Orders */}
          <View style={{alignSelf:'center', flexDirection:'column', margin:10, backgroundColor:'transparent', }}>

          <Text style={[FontInfo.appStyles.txt_bold, {alignSelf:'center', color:FontInfo.sForeground, }]}>Working Orders</Text>

          <View style={{backgroundColor:'transparent', flexDirection:'row'}}>
            <TouchableOpacity style={{borderRadius:5, 
                backgroundColor:this.state.wo_type==Order.WO_COUNT? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>{this.setState({wo_type:Order.WO_COUNT})}}> 
                <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, paddingHorizontal:6, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Count</Text>
             </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.wo_type==Order.WO_QTY? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
             onPress={()=>{this.setState({wo_type:Order.WO_QTY})}}> 

              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, paddingHorizontal:6, minWidth:40, color:'rgba(255,255,255,.8)'}]}>B/S Size</Text>
            </TouchableOpacity>

          </View>
          </View>

          {/* OB Levels */}
          <View style={{margin:10, alignItems:'center', marginTop:10, alignContent:'center', justifyContent:'center', backgroundColor:'transparent'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, letterSpacing:0, }]}>Order Book Prices</Text>

          <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementLevels(100)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementLevels()}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.book_levels}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementLevels()}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementLevels(100)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>
          </View>


          {/* Def Qty */}
          {/* <View style={{margin:10, alignItems:'center', marginTop:10, alignContent:'center', justifyContent:'center', backgroundColor:'transparent'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, letterSpacing:0, }]}>Qty</Text>

          <View style={{marginTop:-5, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementDef(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementDef()}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.evt? this.state.def_qty_evt : this.state.def_qty}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementDef()}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementDef(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>
          </View> */}




        </View>
    );
  }

  /*   -------------------------------------------------------------------   */

  renderSettings()
  {
    // if (this.state.display_type!=Order.DISPLAY_SETTINGS)
    //   return(null)
    // else
    return (
      <Modal style={{}}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        isVisible={this.state.display_type==Order.DISPLAY_SETTINGS}
        onBackdropPress={()=>this.HideModal()}
        >


      <View style={[styles.row_header_container, {alignSelf:'center', width:DEF_WIDTH,}]}>
      <Text style={[FontInfo.appStyles.txt_bold, styles.row_header, {fontSize: FontInfo.iFontSize + 2,}]}
          >{this.props.oData?.symbol}.{this.props.oData.exchange}</Text>
      </View>

      {/* <View style={{borderBottomStartRadius:20, borderBottomEndRadius:20, backgroundColor:'pink'}}> */}
      <ScrollView horizontal={true} pagingEnabled={true} showsHorizontalScrollIndicator={false}
                    scrollEventThrottle={60}
                    // contentOffset={ {x: this.curr_sett_page * DEF_WIDTH, y: 0} }
                    style={{alignSelf:'center', backgroundColor:FontInfo.sBackgroundTp, minHeight:370,
                            width:DEF_WIDTH, //minHeight:370, 
                            maxHeight:370,  }}

        ref={(node : ScrollView)=>{this.scrollRef = node}}
                                      
        onScroll={e => 
          {
          var currentIndex = Math.round (e.nativeEvent.contentOffset.x/DEF_WIDTH);
        
          //this.dotRef?.SetIndex(currentIndex);
          //this.setOrderPage(currentIndex);

          // if (!this.is_loaded)
          //   return;

          if (this.dotRef?.SetIndex(currentIndex) == true)
            {
            if (__DEV__)              
              Utilities.Sendlog("scroll event");
              
            this.dotClicked(currentIndex, false);
            }
          }}

        // onContentSizeChange={() => 
        //     {
        //     this.is_loaded = true;
        //     this.scrollRef?.scrollTo({x:this.curr_sett_page * DEF_WIDTH, animated: false})
        //     }}
                                          
        >

        <this.renderSettingsDef/>
        <this.renderOptionsBasicDef/>
        <this.renderBracketBasicDef/>

        </ScrollView>


        <DotsOrder ref={(node)=> {this.dotRef=node}}
         is_opt_enabled={this.state.def_order?.cancel_after_en || 
                         this.state.def_order?.cancel_at_en} 
         is_bkt_enabled={this.state.def_order?.bracket_target_en || 
                         this.state.def_order?.bracket_stop_en} 

         clickEvent={this.dotClicked} 
         iIndex={this.state.order_page}
          />

      {/* </View> */}
      </Modal>

    );
  }

  /*   -------------------------------------------------------------------   */

  renderSettings_Old()
  {
    // if (this.state.display_type!=Order.DISPLAY_SETTINGS)
    //   return(null)
    // else
    return (
      <Modal style={{}}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        isVisible={this.state.display_type==Order.DISPLAY_SETTINGS}
        onBackdropPress={()=>this.HideModal()}
        >

      <View style={{alignSelf:'center', minWidth:200, backgroundColor:'transparent'}}>

      <View style={styles.row_header_container}>
      <Text style={[FontInfo.appStyles.txt_bold, styles.row_header, {fontSize: FontInfo.iFontSize + 2,}]}>{this.props.oData?.symbol}.{this.props.oData.exchange}</Text>
      </View>

      {/* <View style={{alignSelf:'center', backgroundColor:'rgba(0,0,0,.7)', flexDirection:'column', borderBottomLeftRadius:15, borderBottomRightRadius:15}}> */}

      {/* <ScrollView> */}
      <View style={{alignSelf:'center', backgroundColor:FontInfo.sBackgroundTp, flexDirection:'column', borderBottomLeftRadius:15, borderBottomRightRadius:15,
                    alignItems:'center', alignContent:'center', justifyContent:'center'}}>


      <RNPickerSelect
                 style={GetPickerStyles()}
                 onValueChange={(sValue, iIndex) => {  this.ChangeAccount(sValue); /*iSystemIndex = iIndex; */ }}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={this.GetAccounts()}
                 //itemKey={this.state.pos_data?.acc_key}
                 value={this.state.pos_data?.acc_key}

                //  items={[
                //      { label: "Rithmic Paper Trading", value: "Rithmic Paper Trading" },
                //      { label: "Rithmic Paper Trading (beta)", value: "Rithmic Paper Trading (beta)" },
                //  ]}
             />

        {/* <View style={styles.row_header_container}>
        <Text style={styles.row_header}>{this.props.oData?.symbol}.{this.props.oData.exchange}</Text>
        </View> */}

        {/* <View style={{flexDirection:'row', height:25, backgroundColor:'black'}}>
        </View> */}

        {/* Confirm */}
        <View style={{flexDirection:'column', margin:10, backgroundColor:'transparent', }}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, }]}>Confirm Actions</Text>
          <SwitchNE style={{alignSelf:'center', marginTop:5, marginLeft:8, paddingBottom:0, margin:Platform.OS=='android'?-10:0, backgroundColor:'transparent'}}
                  trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
                  ios_backgroundColor={FontInfo.sGrayTp}
                  onValueChange={(value : boolean)=>{ 
                                                    for (let i = 0; i < this.onConfirmApply.length; i++)
                                                      {
                                                      this.onConfirmApply[i](Order.MSG_CHANGE_CONFIRM, value);
                                                      }
                
                                                      // if (this.onConfirmApply) 
                                                      //   this.onConfirmApply(value); 


                                                      this.setState({confirm_actions:value}) }}
                  value={this.state.confirm_actions}
                />
          </View>

          {/* P&L */}
          <View style={{alignSelf:'center', flexDirection:'column', margin:10, backgroundColor:'transparent', }}>

          <Text style={[FontInfo.appStyles.txt_bold, {alignSelf:'center', color:FontInfo.sForeground, }]}>P&L</Text>

          <View style={{backgroundColor:'transparent', flexDirection:'row'}}>
            <TouchableOpacity style={{borderRadius:5, 
                backgroundColor:this.state.pnl_type==Order.PNL_AUTO? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>{this.setState({pnl_type:Order.PNL_AUTO})}}> 
                <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Auto</Text>
             </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.pnl_type==Order.PNL_OPEN? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
             onPress={()=>{this.setState({pnl_type:Order.PNL_OPEN})}}> 

              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Open</Text>
            </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.pnl_type==Order.PNL_TOTAL? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}} //'rgba(152,251,152,.9)'
              onPress={()=>{this.setState({pnl_type:Order.PNL_TOTAL})}}> 
              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Total</Text>
            </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.pnl_type==Order.PNL_OFF? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>{this.setState({pnl_type:Order.PNL_OFF})}}> 
              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Off</Text>
            </TouchableOpacity>

          </View>
          </View>

          {/* Working Orders */}
          <View style={{alignSelf:'center', flexDirection:'column', margin:10, backgroundColor:'transparent', }}>

          <Text style={[FontInfo.appStyles.txt_bold, {alignSelf:'center', color:FontInfo.sForeground, }]}>Working Orders</Text>

          <View style={{backgroundColor:'transparent', flexDirection:'row'}}>
            <TouchableOpacity style={{borderRadius:5, 
                backgroundColor:this.state.wo_type==Order.WO_COUNT? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
              onPress={()=>{this.setState({wo_type:Order.WO_COUNT})}}> 
                <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, paddingHorizontal:6, minWidth:40, color:'rgba(255,255,255,.8)'}]}>Count</Text>
             </TouchableOpacity>

            <TouchableOpacity style={{borderRadius:5, 
              backgroundColor:this.state.wo_type==Order.WO_QTY? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
             onPress={()=>{this.setState({wo_type:Order.WO_QTY})}}> 

              <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, paddingHorizontal:6, minWidth:40, color:'rgba(255,255,255,.8)'}]}>B/S Size</Text>
            </TouchableOpacity>

          </View>
          </View>

          {/* OB Levels */}
          <View style={{display:this.props.oData.visible_index!=1? 'none' : 'flex', margin:10, alignItems:'center', marginTop:10, alignContent:'center', justifyContent:'center', backgroundColor:'transparent'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, letterSpacing:0, }]}>Order Book Prices</Text>

          <View style={{marginTop:-5, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementLevels(100)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementLevels()}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.book_levels}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementLevels()}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementLevels(100)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>
          </View>


          {/* Def Qty */}
          <View style={{margin:10, alignItems:'center', marginTop:10, alignContent:'center', justifyContent:'center', backgroundColor:'transparent'}}>
          <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, letterSpacing:0, }]}>Qty</Text>

          <View style={{marginTop:-5, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementDef(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.DecrementDef()}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.evt? this.state.def_qty_evt : this.state.def_qty}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementDef()}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementDef(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>
          </View>




        </View>
        {/* </ScrollView> */}
      </View>

      {/* </View> */}
      </Modal>

    );
  }

  /*   -------------------------------------------------------------------   */

  // readonly getIndicator = (iIndex : number) =>
  // {
  // let oIndicator : boolean[] = new Array(this.state.indicators.length);

  // oIndicator[iIndex] = !this.state.indicators[iIndex];

  // return(oIndicator);
  // }
  

  /*   -------------------------------------------------------------------   */

  // readonly getIndicatorString = () =>
  // {
  // for (let i = 0; i < this.state.indicators.length; i++)
  //   {
  //   if (this.state.indicators[i])
  //     return(ConnectionHis.oIndicators[i].sDesc);
  //   }

  //   return(" ");
  // }

  /*   -------------------------------------------------------------------   */

  readonly getPeriodString = (oPd : IPeriodInfo) =>
  {
  if (oPd == undefined)
    return("");

  if (!oPd.iPeriod2)
    return oPd.iPeriod1.toFixed();
  else
    return oPd.iPeriod2 + "/" + oPd.iPeriod1;
  }

  /*   -------------------------------------------------------------------   */

  async informAll(iMsg : number, oApply: any)
  {
  for (let i = 0; i < this.onConfirmApply.length; i++)
    {
    this.onConfirmApply[i](iMsg, oApply);
    }
  }

  /*   -------------------------------------------------------------------   */

  // renderChartInfo()
  // {
  //   // if (this.state.display_type!=Order.DISPLAY_CHART_INFO)
  //   //   return(null);
  //   // else
  //   return (
  //     <Modal style={{}}
  //       useNativeDriver={true}
  //       useNativeDriverForBackdrop={true}
  //       backdropOpacity={0.0}
  //       animationInTiming={400}
  //       animationOutTiming={300}
  //       animationIn={"bounceInLeft"}
  //       animationOut={"slideOutLeft"}
  //       backdropTransitionOutTiming={0}
  //       hideModalContentWhileAnimating={true}
  //       isVisible={this.state.display_type==Order.DISPLAY_CHART_INFO}
  //       onBackdropPress={()=>this.HideModal()}
  //       >

  //     <View style={{alignSelf:'center', minWidth:200, minHeight:100, padding:20, 
  //                   justifyContent:'center', alignItems:'center', 
  //                   borderRadius:20, backgroundColor:FontInfo.sBackgroundTp}}>

  //     {/* <View style={styles.row_header_container}>
  //     <Text style={styles.row_header}>{this.props.oData?.symbol}.{this.props.oData.exchange}</Text>
  //     </View> */}

  //     {/* <Text style={{color:'rgba(255,255,255, .9)', fontSize:12, 
  //                   fontStyle:'normal'}}>Chart Update Times</Text> */}

  //     <View style={{flexDirection:'row'}}>
  //     <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, color:FontInfo.sGreen, opacity:.9, }]}>1Min</Text>
  //     <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize+2, marginLeft:2, color:FontInfo.sForeground, opacity:.9, fontWeight:'normal'}]}>updates every second</Text>
  //     </View>

  //     <View style={{flexDirection:'row'}}>
  //     <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, color:FontInfo.sGreen, opacity:.9, }]}>5Min</Text>
  //     <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize+2, marginLeft:2, color:FontInfo.sForeground, opacity:.9, fontWeight:'normal'}]}>updates every 3 seconds</Text>
  //     </View>

  //     <View style={{flexDirection:'row'}}>
  //     <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, color:FontInfo.sGreen, opacity:.9, }]}>1Hr</Text>
  //     <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize+2, marginLeft:2, color:FontInfo.sForeground, opacity:.9, }]}>updates every minute</Text>
  //     </View>

  //     <View style={{flexDirection:'row'}}>
  //     <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, color:FontInfo.sGreen, opacity:.9, }]}>1D</Text>
  //     <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize+2, marginLeft:2, color:FontInfo.sForeground, opacity:.9, }]}>updates every 30 minutes</Text>
  //     </View>

  //     <View style={{flexDirection:'row'}}>
  //     <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, color:FontInfo.sGreen, opacity:.9, }]}>2W, 1M, 3M, 1Y</Text>
  //     <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize+2, marginLeft:2, color:FontInfo.sForeground, opacity:.9, }]}>updates daily</Text>
  //     </View>

  //     <SwitchNE style={Platform.OS=='android'? {marginTop:20, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} :
  //                                              {marginTop:20, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
  //         trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
  //         ios_backgroundColor={FontInfo.sGrayTp}
  //         onValueChange={(value)=> {
  //                                   this.setState({candles: value}); 

  //                                   this.informAll(Order.MSG_CHANGE_CANDLES, value);
  //                                   // for (let i = 0; i < this.onConfirmApply.length; i++)
  //                                   // {
  //                                   // this.onConfirmApply[i](Order.MSG_CHANGE_CANDLES, value);
  //                                   // }
  
  //                                   }  }
  //         value={this.state.candles}
  //       />

  //       <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Show Candlesticks</Text>

  //       <View style={{backgroundColor:'transparent', flexDirection:'row', marginTop:10}}>
  //           {
  //           ConnectionHis.oIndicators.map((oInd: IndicatorInfo, iIndex: number)=> 
  //           {
  //             return(
  //               <TouchableOpacity key={iIndex} style={{borderRadius:5, 
  //                 backgroundColor:this.state.indicators[iIndex]? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
  //                 onPress={()=>
  //                   {
  //                     let oInds : boolean[] = new Array(this.state.indicators.length);

  //                     // if (this.state.indicators[iIndex] == undefined)
  //                     //   oInds[iIndex] = this.state.period_index;

  //                     //if (this.state.indicators[iIndex] == undefined)
  //                       oInds[iIndex] = !this.state.indicators[iIndex];

  //                     this.setState(  {indicators: oInds, indicator: oInds[iIndex]? iIndex : undefined}  );

  //                     this.informAll(Order.MSG_CHANGE_INDICATOR, oInds[iIndex]? iIndex : undefined);

  //                     // for (let i = 0; i < this.onConfirmApply.length; i++)
  //                     //   {
  //                     //   this.onConfirmApply[i](Order.MSG_CHANGE_INDICATOR, oInds[iIndex]? iIndex : undefined);
  //                     //   }

  //                   }}> 
  //                 <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>{ConnectionHis.oIndicators[iIndex].sId}</Text>

  //              </TouchableOpacity>
  //           )})
  //           }

  //           {/* <TouchableOpacity style={{borderRadius:5, 
  //               backgroundColor:this.state.indicators[Order.IND_BB]? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
  //             onPress={()=>{this.setState(   {indicators: this.getIndicator(Order.IND_BB)}  )}}> 
  //               <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>BB</Text>
  //            </TouchableOpacity>

  //           <TouchableOpacity style={{borderRadius:5, 
  //             backgroundColor:this.state.indicators[Order.IND_SMA]? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}}
  //            onPress={()=>{this.setState(  {indicators: this.getIndicator(Order.IND_SMA)}  )}}> 

  //             <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>SMA</Text>
  //           </TouchableOpacity>

  //           <TouchableOpacity style={{borderRadius:5, 
  //             backgroundColor:this.state.indicators[Order.IND_EMA]? FontInfo.sLightGreen : 'rgba(105,105,105,.6)', margin:5,}} //'rgba(152,251,152,.9)'
  //             onPress={()=>{this.setState(  {indicators: this.getIndicator(Order.IND_EMA)}   )}}> 
  //             <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', padding:5, minWidth:40, color:'rgba(255,255,255,.8)'}]}>EMA</Text>
  //           </TouchableOpacity> */}

  //         </View>

  //       <Text style={[FontInfo.appStyles.txt_bold, {marginTop:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>{this.state.indicator != undefined? ConnectionHis.oIndicators[this.state.indicator].sDesc : ""}</Text>  


  //       <View style={{backgroundColor:'transparent', flexDirection:'row', marginTop:5}}>
  //         {
  //         this.state.indicator==undefined? null : 

  //         ConnectionHis.oIndicators[this.state.indicator].oPeriods.map((oPdInfo : IPeriodInfo, iIndex: number)=>{
  //           return(

  //             <TouchableOpacity key={iIndex} style={{backgroundColor:'transparent', marginHorizontal:0}}
  //               onPress={()=>
  //                 {
  //                   this.setState(  {period_index: iIndex}  );
  //                   this.informAll(Order.MSG_CHANGE_PERIOD, iIndex);
  //                 }}
  //              >

  //             <View style={{backgroundColor:'transparent', marginHorizontal:10, paddingHorizontal:2, paddingTop:0,
  //                           borderBottomColor:FontInfo.sLightGreen,
  //                           borderBottomWidth: this.state.period_index==iIndex? 2:0,  }}>
  //               <Text key={iIndex}
  //                     style={[FontInfo.appStyles.txt_bold, {textAlign:'center', 
  //                             //borderWidth:2, borderColor:'white',
  //                             //borderBottomWidth: this.state.period_index==iIndex? 2:0,//'underline':'none', 
  //                             //borderBottomColor:FontInfo.sLightGreen, 
  //                             padding:5, 
  //                             color:FontInfo.sForeground}]}
  //               >
  //               {this.state.indicator==undefined? "" : this.getPeriodString(ConnectionHis.oIndicators[this.state.indicator].oPeriods[iIndex])}
  //               </Text>
  //               {/* <View style={{minWidth:40, height:2, 
  //                             backgroundColor: this.state.period_index==iIndex? FontInfo.sLightGreen : 'transparent'}}>
  //               </View> */}

  //             </View>
  //             </TouchableOpacity>

  //           )})

  //         }
  //       </View>

  //     </View>

  //     {/* </View> */}
  //     </Modal>

  //   );
  // }

  /*   -------------------------------------------------------------------   */

  renderNoOrder()
  {
    // if (this.state.display_type!=Order.DISPLAY_NO_ORDER)
    //   return(null);
    // else
    return (
      <Modal style={{}}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        isVisible={this.state.display_type==Order.DISPLAY_NO_ORDER}
        onBackdropPress={()=>this.HideModal()}
        >

      <View style={{alignSelf:'center', minWidth:200, maxWidth:Utilities.WIDTH - 10, minHeight:100, padding:20, 
                    justifyContent:'center', alignItems:'center', 
                    borderRadius:20, backgroundColor:FontInfo.sBackgroundTp}}>

      {/* <View style={styles.row_header_container}>
      <Text style={styles.row_header}>{this.props.oData?.symbol}.{this.props.oData.exchange}</Text>
      </View> */}

      {/* <Text style={{color:'rgba(255,255,255, .9)', fontSize:12, 
                    fontStyle:'normal'}}>Chart Update Times</Text> */}

      <View style={{flexDirection:'row'}}>
      <Text style={this.state.display_txt_style? this.state.display_txt_style :
                   [FontInfo.appStyles.txt_black, {fontSize:FontInfo.iFontSize+6, 
                    color:'red', opacity:.9, }]}>{this.state.display_txt? this.state.display_txt : "Trading not available"}</Text>
      </View>

      </View>

      {/* </View> */}
      </Modal>

    );
  }

  /*   -------------------------------------------------------------------   */

  renderCxtStatus()
  {
    return (
      <Modal style={{}}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        isVisible={this.state.display_type==Order.DISPLAY_CXT_STATUS}
        onBackdropPress={()=>this.HideModal()}
        >

      <View style={{alignSelf:'center', minWidth:200, minHeight:100, padding:20, 
                    justifyContent:'center', alignItems:'center', flexDirection:'column',
                    borderRadius:20, backgroundColor:'rgba(0,0,0, .5)'}}>

      {/* <View style={styles.row_header_container}>
      <Text style={styles.row_header}>{this.props.oData?.symbol}.{this.props.oData.exchange}</Text>
      </View> */}

      {/* <Text style={{color:'rgba(255,255,255, .9)', fontSize:12, 
                    fontStyle:'normal'}}>Chart Update Times</Text> */}

      <View style={{flexDirection:'row'}}>
      <LED bindEvent={this.props.bindEvent} getCxtState={Connection.GetMktState}
           style={{width:10, marginRight:-1, height:10, borderRadius:5,alignSelf:'center'}}
      />
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, 
                    color:'green', opacity:.9, }]}>Market Data</Text>
      </View>

      <View style={{flexDirection:'row'}}>
      <LED bindEvent={this.props.bindEvent} getCxtState={Connection.GetOrdState}
           style={{width:10, marginRight:-1, height:10, borderRadius:5,alignSelf:'center'}}
      />
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, 
                    color:'green', opacity:.9, }]}>Orders</Text>
      </View>


      </View>

      {/* </View> */}
      </Modal>

    );
  }

  /*   -------------------------------------------------------------------   */

  ApplyPriceType(sValue  : any,
                 iIndex? : number)
  {
  let iValue = Number.parseInt(sValue);

  if (this.state.price_type == iValue)
    return;

  //alert("type: " + typeof(sValue) +  " new value:" + iValue + " index:" + iIndex + " old value:" + this.iPriceType + " old state:" + this.state.price_type);

  this.iPriceType = iValue;

  if (iValue == PriceType.MARKET)
    this.setState({price_type:this.iPriceType, buy_conf:this.state.buy_conf_org, sell_conf:this.state.sell_conf_org});
  else
    this.setState({price_type:this.iPriceType, price: this.GetAPrice(), buy_conf:this.state.buy_conf_org, sell_conf:this.state.sell_conf_org});

  // else if (iValue == PriceType.LIMIT)
  //   this.setState({price_type:this.iPriceType, price: this.GetAPrice(), buy_conf:this.state.buy_conf_org, sell_conf:this.state.sell_conf_org});
  // else
  //     {
  //     let bBuyConf  = false;
  //     let bSellConf = false;

  //     if (this.state.buy_conf_org == true)
  //       {
  //         bBuyConf  = false;
  //         bSellConf = true;
  //       }
  //     else if (this.state.sell_conf_org == true)
  //       {
  //         bBuyConf  = true;
  //         bSellConf = false;
  //       }

  //     this.setState({price_type:this.iPriceType, price: this.GetAPrice(), buy_conf:bBuyConf, sell_conf:bSellConf}); /*iSystemIndex = iIndex; */
  //     }
  }

    /*   -------------------------------------------------------------------   */

  renderOrderConf1()
  {
    // if (this.state.display_type!=Order.DISPLAY_TRADE_BAR_CONF)
    //   return(null);
    // else
    return (
      <Modal style={{}}
        // deviceWidth={this.iDeviceWidth}
        // deviceHeight={this.iDeviceHeight}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        // deviceWidth={deviceWidth}
        // deviceHeight={deviceHeight + 200}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        //isVisible={this.state.conf_visible}
        isVisible={this.state.display_type==Order.DISPLAY_TRADE_BAR_CONF}
        onBackdropPress={()=>this.HideModal()}
        //onModalWillHide={()=>{alert()}}
        //onDismiss={()=>{alert()}}
        >

      <View style={[styles.row_header_container, {alignSelf:'center', width:300,}]}>
      <Text style={[FontInfo.appStyles.txt_bold, styles.row_header, {fontSize: FontInfo.iFontSize + 2,}]}>{this.state.pos_data?.token}</Text>
      </View>

        {/* <View style={{width:300, height:25, alignSelf:'center', alignItems:'center', backgroundColor:'rgba(0, 0, 0, .9)', borderTopRightRadius:15, borderTopLeftRadius:15, }} >
        <Text style={[FontInfo.appStyles.txt_bold, {paddingTop:4, color:'white', }]}>{this.state.pos_data?.token}</Text>
        </View> */}

        <ScrollView horizontal={true} style={{alignSelf:'center', backgroundColor:'transparent', width:300, minHeight:360, 
                                              maxHeight:360, borderBottomStartRadius:15, borderBottomEndRadius:15, }}>

        <View style={{alignSelf:'center', flexDirection:'column', alignItems:'center', borderBottomStartRadius:15,
                      borderBottomEndRadius:15, width:300, minHeight:360, backgroundColor:FontInfo.sBackgroundTp}}>

        {/* <View style={{position:'absolute', marginHorizontal:10, top:10, left:0, width:280, height:40, alignItems:'center', justifyContent:'center', backgroundColor:'yellow'}}> */}
          <RNPickerSelect
                 style={GetPickerStyles()}
                 onValueChange={(sValue, iIndex) => {  this.ChangeAccount(sValue); /*iSystemIndex = iIndex; */ }}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={this.GetAccounts()}
                 //itemKey={this.state.pos_data?.acc_key}
                 value={this.state.pos_data?.acc_key}

                //  items={[
                //      { label: "Rithmic Paper Trading", value: "Rithmic Paper Trading" },
                //      { label: "Rithmic Paper Trading (beta)", value: "Rithmic Paper Trading (beta)" },
                //  ]}
             />
          {/* </View> */}

          <this.renderAccBalance/>
          {/* <View style={{flexDirection:'row', marginBottom:10}}>
          <FontAwesome5 name="money-bill-wave" style={{marginTop:1,}} size={12} color="green" />
          <Text3Eqv bindEvent={this.props.bindEvent} 
                    getStyle={()=>
                        {
                        if (this.oAccData?.acc_balance)
                          return([FontInfo.appStyles.txt_bold, {marginLeft:2, color:FontInfo.sForeground}])
                        else
                          return([FontInfo.appStyles.txt_bold, {marginLeft:2, color:'red'}])
                        }}
                    getText={()=>
                        {
                          if (this.oAccData?.acc_balance) 
                            return("Balance " + this.oAccData?.acc_balance.toString());
                          else
                            return("Trading not available");
                         }} />
          </View> */}

          <View style={{alignSelf: 'center', marginTop: 8, marginBottom:10, 
                        height: 1, width: (Utilities.WIDTH * 0.8) - 50, opacity:1,
                        backgroundColor:FontInfo.sBorder}} />

          <View style={{alignItems:'center', alignContent:'center', justifyContent:'center', backgroundColor:'transparent'}}>

            <View style={{flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
              <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4, 
                  width:B_BIG, height:B_BIG, borderRadius:B_BIG/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Decrement(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4,
                  width:B_SMALL, height:B_SMALL, borderRadius:B_SMALL/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Decrement()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.qty}</Text>

              <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4, 
                  width:B_SMALL, height:B_SMALL, borderRadius:B_SMALL/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Increment()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4, 
                 width:B_BIG, height:B_BIG, borderRadius:B_BIG/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Increment(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>
            </View>

         </View>

         <View style={{flexDirection:'row'}}>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.STOP_MARKET? this.state.buy_conf?"dodgerblue":"hotpink" :'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.STOP_MARKET)}}
            >
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.STOP_MARKET? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>SM</Text>
        </TouchableOpacity>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.STOP_LIMIT? this.state.buy_conf?"dodgerblue":"hotpink":'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.STOP_LIMIT)}}
            >
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.STOP_LIMIT? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>SL</Text>
        </TouchableOpacity>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.LIMIT? this.state.buy_conf?"dodgerblue":"hotpink" :'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.LIMIT)}}
            >
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.LIMIT? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>L</Text>
        </TouchableOpacity>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.MARKET? this.state.buy_conf?"dodgerblue":"hotpink":'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.MARKET)}}
            >
          <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.MARKET? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>M</Text>
        </TouchableOpacity>

         </View>
         <Text style={[FontInfo.appStyles.txt_normal, {fontSize: FontInfo.iFontSize + 2, color:FontInfo.sForeground}]}>{PriceType.GetDisplay(this.state.price_type)}</Text>
         {/* <RNPickerSelect
                 style={{ ...pickerSelectStyles  }}
                 onValueChange={(sValue, iIndex)=>{this.ApplyPriceType(sValue, iIndex)}}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={this.GetPriceTypes()}
                 //itemKey={(item) => {return(item.key.toString())}}
                 value={this.state.price_type.toString()} //()=>{return(this.state.price_type)}}
             /> */}

            <View style={this.state.price_type==PriceType.MARKET? {display:'none'} : {marginBottom:2, alignItems:'center', alignContent:'center', justifyContent:'center', backgroundColor:'transparent', }}>

            <View style={{flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_BIG_PRICE, height:B_BIG_PRICE, borderRadius:B_BIG_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.DecrementPrice(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_SMALL_PRICE, height:B_SMALL_PRICE, borderRadius:B_SMALL_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.DecrementPrice()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:70, textAlign:'center', alignSelf:'center', }]}>{ConnectionMkt.getFmtUndefined(this.state.price, this.props.oData)}</Text>

              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_SMALL_PRICE, height:B_SMALL_PRICE, borderRadius:B_SMALL_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.IncrementPrice()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_BIG_PRICE, height:B_BIG_PRICE, borderRadius:B_BIG_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.IncrementPrice(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

            </View>
            </View>


         {/* <View style={{position:'absolute', marginHorizontal:10, bottom:5, left:0, width:280, height:40, alignItems:'center', justifyContent:'center', backgroundColor:'yellow'}}>
         </View> */}
        </View>

        </ScrollView>


        <View style={{flexDirection:'row', backgroundColor:'transparent', alignSelf:'center', }}>

        <TouchableOpacity
            style={{backgroundColor:FontInfo.sBackgroundTp, margin:10, borderRadius:30, alignItems:'center', 
                                    justifyContent:'center', height:60, width:60, }}
            onPress={()=>
              {
              }}>

           <Ionicons name="options" size={24} color={FontInfo.sForeground} />
            {/* <MaterialIcons name="settings" size={24} color="black" /> */}
            {/* <Ionicons name="settings-outline" size={24} color="black" /> */}

            {/* <Text style= {[FontInfo.appStyles.txt_normal, {color:'lightgreen', textAlign:'center'}]
                          }>{"Options"}</Text> */}
        </TouchableOpacity>

        <TouchableOpacity
            style={[this.state.buy_conf? {backgroundColor:FontInfo.bTransparency?'rgba(30,144,255,.95)':'rgba(30,144,255,1)', //dodgerblue
                                           alignSelf:'center', margin:10, borderRadius:45, alignItems:'center', 
                                           justifyContent:'center', minHeight:90, minWidth:90, } :
                                         {backgroundColor:FontInfo.bTransparency?'rgba(255,105,180,.95)':'rgba(255,105,180,1)', //hotpink
                                          alignSelf:'center', margin:10, borderRadius:45, alignItems:'center', 
                                          justifyContent:'center', minHeight:90, minWidth:90, }]}
            onPress={()=>
              {
              if (Connection.IsOrderAvailable() == false)
                {
                this.ShowNoOrder();  
                return;
                }
            
                //alert(PriceType.GetDisplay( Number.parseInt(this.iPriceType.toString())) );
                //return;

                ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                                   this.props.oData.token,
                                                   this.state.buy_conf? TransactionType.BUY : TransactionType.SELL,
                                                   this.state.qty,
                                                   this.state.window_name? this.state.window_name + ", Confirm" : "Confirm",
                                                   this.state.price_type,
                                                   this.state.price);
                this.HideModal();

              }}
              >
            <Text style= {this.state.buy_conf? [FontInfo.appStyles.txt_bold, {minWidth:70, fontSize: FontInfo.iFontSize + 6, color:'white', textAlign:'center'}] :
                                               [FontInfo.appStyles.txt_bold, {minWidth:70, fontSize: FontInfo.iFontSize + 6, color:'white', textAlign:'center'}]
                          }>{this.state.buy_conf? "Buy" : "Sell"}</Text>
            </TouchableOpacity>

          <TouchableOpacity
            style={{backgroundColor:FontInfo.sBackgroundTp, margin:10, borderRadius:30, alignItems:'center', 
                                    justifyContent:'center', height:60, width:60, }}
            onPress={()=>
              {
              }}>

            <MaterialCommunityIcons name="code-brackets" size={24} color={FontInfo.sForeground} />

            {/* <Text style= {[FontInfo.appStyles.txt_normal, {color:'purple', textAlign:'center'}]
                          }>{"[]"}</Text> */}
          </TouchableOpacity>


          </View>

      </Modal>

      // <Pressable
      //       onPress={this.HideModal}
      //       style={this.state.modal_visible == false? {display:'none'} : {position: 'absolute', left:0, right:0, zIndex: 200, backgroundColor: 'black', opacity: 0.5, top:0, bottom:0}}
      // ></Pressable>

    );
  }

  /*   -------------------------------------------------------------------   */

  turnOrderPage(iIndex : number)
  {
  if (this.state.order_page == iIndex)
    return;

  this.scrollRef?.scrollTo({x: iIndex * DEF_WIDTH, animated:true});
  }

  /*   -------------------------------------------------------------------   */

  setOrderPage(iIndex : number)
  {
    this.setState({order_page: iIndex});
  }

  /*   -------------------------------------------------------------------   */

  dotClicked(iIndex    : number,
             bScroll   : boolean = true,
             bAnimated : boolean = true) : void
  {
  if (this.curr_order_page == iIndex)
    {
    if (__DEV__)      
      Utilities.Sendlog("SAME page: " + iIndex);
    return;
    }

  this.curr_order_page = iIndex;

  if (bScroll == true)
    this.scrollRef?.scrollTo({x: iIndex * DEF_WIDTH, animated:bAnimated});
  }

  /*   -------------------------------------------------------------------   */

  validateOrder(oDef     : OrdDefault,
                bScroll  : boolean = false,
                bForce   : boolean = false,
                bShowMsg : boolean = false)
  {
  if (oDef.cancel_at_en || bForce)
    {
    let dt = new Date(Date.now())  

    dt.setHours(oDef.cancel_at_hr);
    dt.setMinutes(oDef.cancel_at_min);
    dt.setSeconds(oDef.cancel_at_sec);

    if (__DEV__)
      Utilities.Sendlog("Cancel at: " + dt.toString());

    if (Date.now() > dt.valueOf())
      {
      if (bShowMsg)
        {
          this.ShowNoOrder("Cancel At time is less than the current time",
                           [FontInfo.appStyles.txt_black, {fontSize:FontInfo.iFontSize+2,
                            color:'red', opacity:.9, }] );

        return;  
        }

      this.dotClicked(Order.PAGE_OPTIONS, bScroll);
      
      //this.oCurrOrder.cancel_at_err
      this.setState({cancel_at_err: true});
      this.cancelAtTime = undefined;
      return(false);

      }
    else
      this.cancelAtTime = Math.trunc(dt.valueOf()/1000);
    }

    return(true);  
  }

  /*   -------------------------------------------------------------------   */

  renderOrderConf()
  {
    return (
      <Modal style={{}}
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        backdropOpacity={0.0}
        animationInTiming={400}
        animationOutTiming={300}
        animationIn={"bounceInLeft"}
        animationOut={"slideOutLeft"}
        backdropTransitionOutTiming={0}
        hideModalContentWhileAnimating={true}
        isVisible={this.state.display_type==Order.DISPLAY_TRADE_BAR_CONF}
        onBackdropPress={()=>this.HideModal()}
        >

      <View style={[styles.row_header_container, {alignSelf:'center', width:DEF_WIDTH,}]}>
      <Text style={[FontInfo.appStyles.txt_bold, styles.row_header, {fontSize: FontInfo.iFontSize + 2,}]}>{this.state.pos_data?.token}</Text>
      </View>

        <ScrollView horizontal={true} pagingEnabled={true} showsHorizontalScrollIndicator={false}
                    scrollEventThrottle={60}
                    //contentOffset={ {x: this.state.order_page * DEF_WIDTH, y: 0} }
                    style={{alignSelf:'center', backgroundColor:FontInfo.sBackgroundTp, 
                            width:DEF_WIDTH, minHeight:370, 
                            maxHeight:370, }}

        ref={(node : ScrollView)=>{this.scrollRef = node}}
                                      
        onScroll={e => 
          {
          var currentIndex = Math.round (e.nativeEvent.contentOffset.x/DEF_WIDTH);
        
          //this.dotRef?.SetIndex(currentIndex);
          //this.setOrderPage(currentIndex);

          // if (!this.is_loaded)
          //   return;

          if (this.dotRef?.SetIndex(currentIndex) == true)
            {
            //alert(e.nativeEvent.contentOffset.x)
            if (__DEV__)
              Utilities.Sendlog("scroll event");

            this.dotClicked(currentIndex, false);
            }
          }}

        //  onContentSizeChange={() => 
        //      {
        //     //alert("size")
        //     //this.is_loaded = true;
        //      this.scrollRef?.scrollTo({x:this.state.order_page * DEF_WIDTH, animated: false})
        //      }}
                                          
        >

        <this.renderOrderBasic/>
        <this.renderOptionsBasic/>
        <this.renderBracketBasic/>


        </ScrollView>

        <DotsOrder ref={(node)=> {this.dotRef=node}}
         is_opt_enabled={this.state.curr_order.cancel_after_en || 
                         this.state.curr_order.cancel_at_en} 
         is_bkt_enabled={this.state.curr_order.bracket_target_en || 
                         this.state.curr_order.bracket_stop_en} 
         is_buy={this.state.buy_conf}
         clickEvent={this.dotClicked} 
         iIndex={this.state.order_page}
         submitEvent={()=>
                    {
                      if (Connection.IsOrderAvailable() == false)
                      {
                      this.ShowNoOrder();
                      return;
                      }

                    if (!this.validateOrder(this.state.curr_order, true))
                      return;
                
                    ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                                       this.props.oData.token,
                                                       this.state.buy_conf? TransactionType.BUY : TransactionType.SELL,
                                                       this.state.qty,
                                                       this.state.window_name? this.state.window_name + ", Confirm " : "Confirm",
                                                       this.state.price_type,
                                                       this.state.price,
                                                       this.state.curr_order.cancel_after_en? 
                                                       this.state.curr_order.cancel_after_sec : undefined,
                                                       this.state.curr_order.cancel_at_en? 
                                                       this.cancelAtTime : undefined,
                                                       
                                                       this.state.curr_order.bracket_target_en? 
                                                       this.state.curr_order.bracket_target_tks : undefined,
                                                       this.state.curr_order.bracket_stop_en? 
                                                       this.state.curr_order.bracket_stop_tks : undefined,
                                                       (this.state.curr_order.bracket_target_en || 
                                                        this.state.curr_order.bracket_stop_en)? 
                                                        this.state.curr_order.bracket_stop_trl : undefined
                                                       );
                    this.HideModal();
   
                    }}/>


        {/* <View style={{flexDirection:'row', backgroundColor:'transparent', alignSelf:'center', }}>

        <TouchableOpacity //activeOpacity={1.1}
            style={{backgroundColor:this.state.order_page==Order.PAGE_OPTIONS? 
                    'cornflowerblue' : FontInfo.sBackgroundTp, 
                    margin:10, borderRadius:30, alignItems:'center', justifyContent:'center', height:60, width:60, }}
            onPress={()=>
              {
              this.turnOrderPage(Order.PAGE_OPTIONS);
              }}>

           <Ionicons name="options" size={24} color={FontInfo.sForeground} />
        </TouchableOpacity>

        <View style={{flexDirection:'column'}}>

        <TouchableOpacity //activeOpacity={1.1}
            style={{backgroundColor:'transparent', margin:10, borderRadius:30, alignItems:'center', 
                    alignSelf:'center', justifyContent:'center', height:60, width:60, }}
            onPress={()=>
              {
              this.turnOrderPage(Order.PAGE_ORDER);
              }}>

           <FontAwesome name="circle" size={24} color={ this.state.order_page==Order.PAGE_ORDER? 
                                                        'cornflowerblue' : FontInfo.sForeground} />
        </TouchableOpacity>

        <TouchableOpacity
            style={[this.state.buy_conf? {backgroundColor:FontInfo.bTransparency?'rgba(30,144,255,.95)':'rgba(30,144,255,1)', //dodgerblue
                                           alignSelf:'center', margin:10, borderRadius:45, alignItems:'center', 
                                           justifyContent:'center', minHeight:90, minWidth:90, } :
                                         {backgroundColor:FontInfo.bTransparency?'rgba(255,105,180,.95)':'rgba(255,105,180,1)', //hotpink
                                          alignSelf:'center', margin:10, borderRadius:45, alignItems:'center', 
                                          justifyContent:'center', minHeight:90, minWidth:90, }]}
            onPress={()=>
              {
                if (Connection.IsOrderAvailable() == false)
                  {
                  this.ShowNoOrder();
                  return;
                  }
            
                ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                                   this.props.oData.token,
                                                   this.state.buy_conf? TransactionType.BUY : TransactionType.SELL,
                                                   this.state.qty,
                                                   this.state.price_type,
                                                   this.state.price);
                this.HideModal();

              }}
              >
            <Text style= {this.state.buy_conf? [FontInfo.appStyles.txt_bold, {minWidth:70, fontSize: FontInfo.iFontSize + 6, color:'white', textAlign:'center'}] :
                                               [FontInfo.appStyles.txt_bold, {minWidth:70, fontSize: FontInfo.iFontSize + 6, color:'white', textAlign:'center'}]
                          }>{this.state.buy_conf? "Buy" : "Sell"}</Text>
            </TouchableOpacity>
            </View>


          <TouchableOpacity //activeOpacity={1.1}
            style={{backgroundColor:this.state.order_page==Order.PAGE_BRACKET? 
                    'cornflowerblue' : FontInfo.sBackgroundTp, 
                    margin:10, borderRadius:30, alignItems:'center', justifyContent:'center', height:60, width:60, }}
            onPress={()=>
              {
              this.turnOrderPage(Order.PAGE_BRACKET);
              }}>

            <MaterialCommunityIcons name="code-brackets" size={24} color={FontInfo.sForeground} />

          </TouchableOpacity>


          </View> */}

      </Modal>

    );
  }

  /*   -------------------------------------------------------------------   */

  renderOrderBasic()
  {
    // if (this.state.order_page != Order.PAGE_ORDER)
    //   return(null);

    return (

        <View style={{flexDirection:'column', alignItems:'center', width:300, }}>

        {/* <View style={{position:'absolute', marginHorizontal:10, top:10, left:0, width:280, height:40, alignItems:'center', justifyContent:'center', backgroundColor:'yellow'}}> */}
          <RNPickerSelect
                 style={GetPickerStyles()}
                 onValueChange={(sValue, iIndex) => {  this.ChangeAccount(sValue); /*iSystemIndex = iIndex; */ }}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={this.GetAccounts()}
                 //itemKey={this.state.pos_data?.acc_key}
                 value={this.state.pos_data?.acc_key}

                //  items={[
                //      { label: "Rithmic Paper Trading", value: "Rithmic Paper Trading" },
                //      { label: "Rithmic Paper Trading (beta)", value: "Rithmic Paper Trading (beta)" },
                //  ]}
             />
          {/* </View> */}

          <this.renderAccBalance/>
          {/* <View style={{flexDirection:'row', marginBottom:10}}>
          <FontAwesome5 name="money-bill-wave" style={{marginTop:1,}} size={12} color="green" />
          <Text3Eqv bindEvent={this.props.bindEvent} 
                    getStyle={()=>
                        {
                        if (this.oAccData?.acc_balance)
                          return([FontInfo.appStyles.txt_bold, {marginLeft:2, color:FontInfo.sForeground}])
                        else
                          return([FontInfo.appStyles.txt_bold, {marginLeft:2, color:'red'}])
                        }}
                    getText={()=>
                        {
                          if (this.oAccData?.acc_balance) 
                            return("Balance " + this.oAccData?.acc_balance.toString());
                          else
                            return("Trading not available");
                         }} />
          </View> */}

          <View style={{alignSelf: 'center', marginTop: 8, marginBottom:10, 
                        height: 1, width: (Utilities.WIDTH * 0.8) - 50, opacity:1,
                        backgroundColor:FontInfo.sBorder}} />

          <View style={{alignItems:'center', alignContent:'center', justifyContent:'center', backgroundColor:'transparent'}}>

            <View style={{flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
              <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4, 
                  width:B_BIG, height:B_BIG, borderRadius:B_BIG/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Decrement(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4,
                  width:B_SMALL, height:B_SMALL, borderRadius:B_SMALL/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Decrement()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.qty}</Text>

              <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4, 
                  width:B_SMALL, height:B_SMALL, borderRadius:B_SMALL/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Increment()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', padding:4, 
                 width:B_BIG, height:B_BIG, borderRadius:B_BIG/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.Increment(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>
            </View>

         </View>

         <View style={{flexDirection:'row'}}>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.STOP_MARKET? this.state.buy_conf?"dodgerblue":"hotpink" :'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.STOP_MARKET)}}
            >
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.STOP_MARKET? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>SM</Text>
        </TouchableOpacity>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.STOP_LIMIT? this.state.buy_conf?"dodgerblue":"hotpink":'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.STOP_LIMIT)}}
            >
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.STOP_LIMIT? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>SL</Text>
        </TouchableOpacity>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.LIMIT? this.state.buy_conf?"dodgerblue":"hotpink" :'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.LIMIT)}}
            >
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.LIMIT? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>L</Text>
        </TouchableOpacity>

        <TouchableOpacity style={{backgroundColor:this.state.price_type==PriceType.MARKET? this.state.buy_conf?"dodgerblue":"hotpink":'transparent', 
          alignItems:'center', justifyContent:'center', margin:10, minWidth:40, minHeight:40, borderRadius:5, 
          borderColor:FontInfo.sBorder, borderWidth:1}}

            onPress={()=>{this.ApplyPriceType(PriceType.MARKET)}}
            >
          <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.price_type==PriceType.MARKET? 'white' : this.state.buy_conf?"dodgerblue":"hotpink", fontSize: FontInfo.iFontSize + 2}]}>M</Text>
        </TouchableOpacity>

         </View>
         <Text style={[FontInfo.appStyles.txt_normal, {fontSize: FontInfo.iFontSize + 2, color:FontInfo.sForeground}]}>{PriceType.GetDisplay(this.state.price_type)}</Text>

            <View style={this.state.price_type==PriceType.MARKET? {display:'none'} : {marginBottom:2, alignItems:'center', alignContent:'center', justifyContent:'center', backgroundColor:'transparent', }}>

            <View style={{flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_BIG_PRICE, height:B_BIG_PRICE, borderRadius:B_BIG_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.DecrementPrice(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_SMALL_PRICE, height:B_SMALL_PRICE, borderRadius:B_SMALL_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.DecrementPrice()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:70, textAlign:'center', alignSelf:'center', }]}>{ConnectionMkt.getFmtUndefined(this.state.price, this.props.oData)}</Text>

              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_SMALL_PRICE, height:B_SMALL_PRICE, borderRadius:B_SMALL_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.IncrementPrice()}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

              <TouchableOpacity style={{marginHorizontal:2, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
              padding:4, width:B_BIG_PRICE, height:B_BIG_PRICE, borderRadius:B_BIG_PRICE/2, borderColor:FontInfo.sBorder, borderWidth:1}} onPress={()=>{this.IncrementPrice(10)}}>

              <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {this.state.buy_conf?"dodgerblue":"hotpink"} />
              </TouchableOpacity>

            </View>
            </View>

        </View>
    );
  }

  /*   -------------------------------------------------------------------   */

  renderBracketBasic()
  {
    // if (this.state.order_page != Order.PAGE_BRACKET)
    //   return(null);

    return (

        <View style={{flexDirection:'column', alignItems:'center', width:300, height:'100%'}}>


        <SwitchNE style={Platform.OS=='android'? {marginTop:20, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} :
                                               {marginTop:20, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
          trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
          ios_backgroundColor={FontInfo.sGrayTp}
          onValueChange={(value)=> {this.oCurrOrder.bracket_target_en = value;  this.setState({curr_order: this.oCurrOrder})}}
          value={this.state.curr_order.bracket_target_en}
        />

        <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Bracket Target (Ticks)</Text>

        <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(-10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(-1)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.curr_order.bracket_target_tks}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(1)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTargetTks(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>


        <SwitchNE style={Platform.OS=='android'? {marginTop:20, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} :
                                               {marginTop:20, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
          trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
          ios_backgroundColor={FontInfo.sGrayTp}
          onValueChange={(value)=> {this.oCurrOrder.bracket_stop_en = value;  this.setState({curr_order: this.oCurrOrder})}}
          value={this.state.curr_order.bracket_stop_en}
        />

        <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Bracket Stop (Ticks)</Text>

        <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(-10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(-1)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.curr_order.bracket_stop_tks}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(1)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementStopTks(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>

        <SwitchNE style={Platform.OS=='android'? {marginTop:20, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} :
                                               {marginTop:20, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
          trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
          ios_backgroundColor={FontInfo.sGrayTp}
          onValueChange={(value)=> {this.oCurrOrder.bracket_stop_trl = value;  this.setState({curr_order: this.oCurrOrder})}}
          value={this.state.curr_order.bracket_stop_trl}
        />

        <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Bracket Stop Trailing</Text>

      
        {/* <TouchableOpacity style={{position:'absolute', left:6, top:6, height:20, width:20, }}>
        <MaterialCommunityIcons name="content-save-cog-outline" size={30} color={FontInfo.sGrayTp} />
       </TouchableOpacity> */}

       {/* <View style={{position:'absolute', alignItems:'center', right:6, bottom:0, }}> */}
       <TouchableOpacity style={{position:'absolute', left:8, bottom:0,}}
        onPress={()=>{ 
          this.oCurrOrder.bracket_stop_en   = false;
          this.oCurrOrder.bracket_target_en = false;
          this.oCurrOrder.bracket_stop_trl  = false;
          this.setState({curr_order: this.oCurrOrder});
          }}
        >
       <Ionicons name="checkmark-done-circle-outline" size={30} color={FontInfo.sDimGrayTp} />
       </TouchableOpacity>       

       <TouchableOpacity style={{position:'absolute', right:6, bottom:0,}}
       onPress={()=>{ 
              this.oCurrOrder.bracket_stop_en   = true;
              this.oCurrOrder.bracket_target_en = true;
              this.oCurrOrder.bracket_stop_trl  = true;
              this.setState({curr_order: this.oCurrOrder});
              }}
        >
       <Ionicons name="checkmark-done-circle-sharp" size={30} color={FontInfo.sDimGrayTp} />
       </TouchableOpacity>       
       {/* </View> */}

        </View>
    );
  }

  /*   -------------------------------------------------------------------   */

  renderOptionsBasic()
  {
    // if (this.curr_order_page != Order.PAGE_OPTIONS)
    //   return(
    //     <View style={{flexDirection:'column', alignItems:'center', width:300, }}></View>
    //     );

    return (

        <View style={{flexDirection:'column', alignItems:'center', width:300, }}>


          <SwitchNE style={Platform.OS=='android'? {marginTop:20, marginLeft:8, paddingBottom:0, marginBottom:-10, backgroundColor:'transparent'} :
                         {marginTop:20, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
            trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
            ios_backgroundColor={FontInfo.sGrayTp}
            onValueChange={(value)=> {this.oCurrOrder.cancel_after_en = value;  this.setState({curr_order: this.oCurrOrder})}}
            value={this.state.curr_order.cancel_after_en}
          />

         <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Cancel After (Sec)</Text>


         <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(-10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(-1)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginHorizontal:4, minWidth:30, textAlign:'center', alignSelf:'center', }]}>{this.state.curr_order.cancel_after_sec}</Text>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(1)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementCancelAfter(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color={FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>


          <SwitchNE style={Platform.OS=='android'? {marginTop:20, marginLeft:8, paddingBottom:0, margin:-10, backgroundColor:'transparent'} : 
                                                  {marginTop:20, marginLeft:8, paddingBottom:0, backgroundColor:'transparent'}}
            trackColor={{ false: FontInfo.sGrayTp, true: FontInfo.sLightGreen }}
            ios_backgroundColor={FontInfo.sGrayTp}
            onValueChange={(value)=> 
                {
                this.oCurrOrder.cancel_at_en  = value;  
                //this.oCurrOrder.cancel_at_err = value? !this.validateOrder(false, true) : false;
                this.setState({curr_order: this.oCurrOrder, cancel_at_err: value? !this.validateOrder(this.state.curr_order, false, true) : false});
                //this.setState({cancel_at_en: value, cancel_at_err: value? !this.validateOrder(false, true) : false})
                }}
            value={this.state.curr_order.cancel_at_en}
          />

         <Text style={[FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:FontInfo.sForeground}]}>Cancel At</Text>


         <View style={{marginTop:0, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>

         <View style={{marginTop:-5, flexDirection:'row', backgroundColor:'transparent', justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder, //'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(-10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(-1)}}>
                                        
            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="minus" size={18} color={FontInfo.sLightGreen} />
            </TouchableOpacity>


            {/* Hr */}
            <TouchableOpacity style={{minHeight:30, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      backgroundColor: this.state.curr_order.cancel_at_type == Order.REL_HR? FontInfo.sLightGreen : 'transparent',  }}
              onPress={ ()=>
                { 
                  this.oCurrOrder.cancel_at_type = Order.REL_HR;
                  this.setState({curr_order: this.oCurrOrder}) 

                  //this.setState({cancel_at_type: Order.REL_HR}) 
                } }>            
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.curr_order.cancel_at_type == Order.REL_HR? 'white' : FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{(this.state.curr_order.cancel_at_hr < 10? "0" : "") + this.state.curr_order.cancel_at_hr }</Text>
            </TouchableOpacity>

            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, 
              marginHorizontal:-4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>:</Text>

            {/* Min */}
            <TouchableOpacity style={{minHeight:30, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      backgroundColor: this.state.curr_order.cancel_at_type == Order.REL_MIN? FontInfo.sLightGreen : 'transparent',  }}
              onPress={ ()=>
              { 
                this.oCurrOrder.cancel_at_type = Order.REL_MIN;
                this.setState({curr_order: this.oCurrOrder}) 

                //this.setState({cancel_at_type: Order.REL_MIN}) 
              } }>
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.curr_order.cancel_at_type == Order.REL_MIN? 'white' : FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{(this.state.curr_order.cancel_at_min < 10? "0" : "") + this.state.curr_order.cancel_at_min }</Text>
            </TouchableOpacity>            

            {/* <TouchableOpacity style={{minHeight:30, borderWidth:1, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      borderColor: this.state.release_at_type == Order.REL_MIN? FontInfo.sBorder : 'transparent', backgroundColor:'transparent' }}
              onPress={ ()=>{ this.setState({release_at_type: Order.REL_MIN}) } }>
            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, backgroundColor:'transparent',
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{(this.state.release_at_min < 10? "0" : "") + this.state.release_at_min }</Text>
            </TouchableOpacity> */}

            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, 
              marginHorizontal:-4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>:</Text>

            {/* Sec */}
            <TouchableOpacity style={{minHeight:30, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      backgroundColor: this.state.curr_order.cancel_at_type == Order.REL_SEC? FontInfo.sLightGreen : 'transparent',  }}
              onPress={ ()=>
              { 
              this.oCurrOrder.cancel_at_type = Order.REL_SEC;
              this.setState({curr_order: this.oCurrOrder}) 

              //this.setState({cancel_at_type: Order.REL_SEC}) 
              } }>
            <Text style={[FontInfo.appStyles.txt_bold, {color: this.state.curr_order.cancel_at_type == Order.REL_SEC? 'white' : FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{(this.state.curr_order.cancel_at_sec < 10? "0" : "") + this.state.curr_order.cancel_at_sec }</Text>
            </TouchableOpacity>            

            {/* <TouchableOpacity style={{minHeight:30, borderWidth:1, borderRadius:5, alignItems:'center', alignContent:'center', flexDirection:'row',
                                      borderColor: this.state.release_at_type == Order.REL_SEC? FontInfo.sBorder : 'transparent', backgroundColor:'transparent' }}
              onPress={ ()=>{ this.setState({release_at_type: Order.REL_SEC}) } }>            
            <Text style={[FontInfo.appStyles.txt_bold, {color: FontInfo.sForeground, 
              marginHorizontal:4, minWidth:20, textAlign:'center', alignSelf:'center', }]}>{ (this.state.release_at_sec < 10? "0" : "") + this.state.release_at_sec}</Text>
            </TouchableOpacity> */}

            <TouchableOpacity style={{marginHorizontal:4, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(1)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen} />
            </TouchableOpacity>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                      padding:4, width:B_SETT_BIG, height:B_SETT_BIG, borderRadius:B_SETT_BIG/2, borderColor:FontInfo.sBorder,//'rgba(118,118,118,.5)', 
                                      borderWidth:1}} onPress={()=>{this.IncrementTimeAt(10)}}>

            <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="plus" size={18} color= {FontInfo.sLightGreen}/>
            </TouchableOpacity>
          </View>


         </View>

         <Text style={!this.state.cancel_at_err? {display:'none'} : 
                      [FontInfo.appStyles.txt_bold, {marginVertical:10, fontSize: FontInfo.iFontSize, color:'red'}]}>Time is less than the current time</Text>


        </View>
    );
  }

  /*   -------------------------------------------------------------------   */

  
    constructor(props)
    {
    super(props);

    this.FindValueEvent      = this.FindValueEvent.bind(this);
    this.ApplyPriceType      = this.ApplyPriceType.bind(this);
    this.Refresh             = this.Refresh.bind(this);
    this.GetData             = this.GetData.bind(this);
    this.GetAccounts         = this.GetAccounts.bind(this);
    this.GetPriceTypes       = this.GetPriceTypes.bind(this);
    this.ApplySettings       = this.ApplySettings.bind(this);

    this.SetDefaults         = this.SetDefaults.bind(this);

    this.renderOrderConf     = this.renderOrderConf.bind(this);
    this.renderOptionsBasic  = this.renderOptionsBasic.bind(this);
    this.renderOrderBasic    = this.renderOrderBasic.bind(this);
    this.renderBracketBasic  = this.renderBracketBasic.bind(this);


    this.renderOptionsBasicDef  = this.renderOptionsBasicDef.bind(this);
    this.renderBracketBasicDef  = this.renderBracketBasicDef.bind(this);    
    this.renderSettingsDef      = this.renderSettingsDef.bind(this);
    this.renderSettings         = this.renderSettings.bind(this);

    this.renderSymbolProps   = this.renderSymbolProps.bind(this);
    this.renderAccBalance    = this.renderAccBalance.bind(this);
    
    // this.renderChartInfo     = this.renderChartInfo.bind(this);
    this.renderNoOrder       = this.renderNoOrder.bind(this);
    this.renderCxtStatus     = this.renderCxtStatus.bind(this);
    this.renderBuySellBar    = this.renderBuySellBar.bind(this);
  
    this.ShowSymbolProps     = this.ShowSymbolProps.bind(this);
    this.ShowSettings        = this.ShowSettings.bind(this);
  
    this.HideModal           = this.HideModal.bind(this);
  
    this.Increment           = this.Increment.bind(this);
    this.IncrementDef        = this.IncrementDef.bind(this);
    this.IncrementPrice      = this.IncrementPrice.bind(this);
  
    this.IncrementLevels     = this.IncrementLevels.bind(this);
    this.DecrementLevels     = this.DecrementLevels.bind(this);

    this.IncrementCancelAfter = this.IncrementCancelAfter.bind(this);
    this.IncrementTimeAt      = this.IncrementTimeAt.bind(this);
    this.IncrementTimeAt_Hr   = this.IncrementTimeAt_Hr.bind(this);
    this.IncrementTimeAt_Min  = this.IncrementTimeAt_Min.bind(this);
    this.IncrementTimeAt_Sec  = this.IncrementTimeAt_Sec.bind(this);
  
    this.IncrementTargetTks   = this.IncrementTargetTks.bind(this);
    this.IncrementStopTks     = this.IncrementStopTks.bind(this);

    this.Decrement           = this.Decrement.bind(this);
    this.DecrementDef        = this.DecrementDef.bind(this);
    this.DecrementPrice      = this.DecrementPrice.bind(this);
  
    this.ChangeAccount       = this.ChangeAccount.bind(this);
    this.ChangeAccountForce  = this.ChangeAccountForce.bind(this);
    this.UpdateData          = this.UpdateData.bind(this);
  
    this.CancelAll           = this.CancelAll.bind(this);
    this.Flatten             = this.Flatten.bind(this);

    this.validateOrder       = this.validateOrder.bind(this);
    //this.ShowNoOrder         - this.ShowNoOrder.bind(this);

    this.ShowBuyConf         = this.ShowBuyConf.bind(this);
    this.ShowSellConf        = this.ShowSellConf.bind(this);
    this.ShowOrderConf       = this.ShowOrderConf.bind(this);
  
    //this.SetPriceType        = this.SetPriceType.bind(this);
    this.GetAPrice           = this.GetAPrice.bind(this);
    this.GetPNLColor         = this.GetPNLColor.bind(this);
    this.GetCurrency         = this.GetCurrency.bind(this);
    this.GetPosColor         = this.GetPosColor.bind(this);
    this.GetOrdColor         = this.GetOrdColor.bind(this);
    this.GetOrderText        = this.GetOrderText.bind(this);
  
    this.GetPNLText          = this.GetPNLText.bind(this);
    this.GetPNLTitle         = this.GetPNLTitle.bind(this);

    this.turnOrderPage       = this.turnOrderPage.bind(this);
    this.setOrderPage        = this.setOrderPage.bind(this);
    this.dotClicked          = this.dotClicked.bind(this);

    this.informAll           = this.informAll.bind(this);
    
    /*   -----------------------------------------------------------------   */    
  
    let oSett : ISettings | undefined;

    if (this.props.iSettIndex < ConnectionOrd.oSettings.length &&
      ConnectionOrd.oSettings[this.props.iSettIndex].token == this.props.oData.token)
      oSett = ConnectionOrd.oSettings[this.props.iSettIndex];
    else
      {
      let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
  
    
      //alert(this.sSvAccount)
      //Utilities.Sendlog("Saved account: " + this.sSvAccount + " " + this.props.oData.token);


      //let oDt  = new Date(Date.now());

      /*   -----------------------------------------------------------------   */

      if (z != AppMain.IMAGINARY)
        {
        oSett           = ConnectionOrd.oSettings[z];
        //this.sSvAccount = oSett?.sAccount;
        }
      }

    /*   -----------------------------------------------------------------   */

    if (oSett?.oOrdDefaults)
      this.oDefOrder = ConnectionOrd.CopyOrdDefault(oSett.oOrdDefaults,
                                                    new OrdDefault);

    /*   -----------------------------------------------------------------   */

    // if (!this.oDefOrder && )

    /*   -----------------------------------------------------------------   */    
    

    this.oCurrOrder = ConnectionOrd.GetCurrFromDefault(this.oDefOrder, 
                                                       new OrdDefault());

    /*   -----------------------------------------------------------------   */

    let bConfirm = oSett?.bConfActions != undefined? oSett.bConfActions : true;

    /*   -----------------------------------------------------------------   */

    // let oInd : boolean[] = new Array(3);

    // if (oSett?.oChartSettings?.oIndicators?.length)
    //   {
    //   oInd[oSett?.oChartSettings?.oIndicators[0].iId] = true;
    //   }
    // else if (oSett?.oChartSettings?.oIndicators2?.length)
    //   {
    //   oInd[oSett?.oChartSettings?.oIndicators2[0].iId] = true;
    //   }

    /*   -----------------------------------------------------------------   */      

    this.state   = 
                   {visible:false,
                    buy_conf:false, sell_conf:false,
                    buy_conf_org:false, sell_conf_org:false,
                    //conf_visible:false, sym_prop_visible:false,
                    display_type:Order.DISPLAY_TRADE_BAR,
                    display_txt:"",

                    book_levels:this.props.oData.book_levels,

                    pnl_type:oSett?.iPnlType? oSett.iPnlType : Order.PNL_AUTO,
                    wo_type:oSett?.iWOType? oSett.iWOType : Order.WO_COUNT,
                    confirm_actions:bConfirm,

                    pos_data: this.GetData(this.props.oData.sv_account), //this.GetData(oSett?.sAccount), 

                    qty: 1, 
                    def_qty: oSett?.iDefQty? oSett.iDefQty : 1, 
                    def_qty_evt: oSett?.iDefQtyEvt? oSett.iDefQtyEvt : 1, 
                    evt:false,

                    cancel_all_enabled:!bConfirm, 
                    flatten_enabled:!bConfirm, 
                    reverse_enabled:!bConfirm,

                    price_type:PriceType.MARKET,
                    AnimOp: new Animated.Value(0),
                  
                    order_page: Order.PAGE_ORDER, 
                  
                    def_order: this.oDefOrder,
                    curr_order: this.oCurrOrder,

                    // candles: oSett?.oChartSettings?.bCandles,
                    // indicators: oInd,
                    // indicator: oSett?.oChartSettings?.oIndicators?.length? oSett.oChartSettings.oIndicators[0].iId : undefined,
                    // period_index: oSett?.oChartSettings?.oIndicators?.length? oSett.oChartSettings.oIndicators[0].iPeriodIndex : 0,

                    // cancel_after_sec: 1,
                  
                    // cancel_at_hr: oDt.getHours(),
                    // cancel_at_min: oDt.getMinutes(),
                    // cancel_at_sec: 0,
                    // cancel_at_type: Order.REL_MIN,

                    // bracket_target_tks:1,
                    // bracket_stop_tks:1,
                    };


    //Utilities.Sendlog("order ctr called" + this.state.pos_data?.acc_key + " size: " + Connection.oAccStore.size);


    // if (Connection.oAccStore.keys())
    // this.state      = {visible:false,
    //                    data:0};
    }

  /*   -------------------------------------------------------------------   */

  SlideIn = () => {
    //console.log("sell");

    // this.is_loaded = false;

    Animated.timing(this.state.AnimOp, {
      toValue: DEFAULT_OPACITY,
      duration: 200,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();
  };

  /*   -------------------------------------------------------------------   */

  SlideOut = () => {
    Animated.timing(this.state.AnimOp, {
      toValue: 0,
      duration: 100,
      useNativeDriver:true
    }).start(()=>{});
  };

  /*   -------------------------------------------------------------------   */

  public ShowSymbolProps()
  {
  ModalEx.oModalEx?.Show();
  this.setState({display_type:Order.DISPLAY_SYMBOL_PROPS});//conf_visible:false, sym_prop_visible:true});
  this.SlideIn();
  }

  /*   -------------------------------------------------------------------   */

  public ShowSettings(bEvt : boolean)
  {
  ModalEx.oModalEx?.Show();

  this.SetDefaults(true, false);


  this.curr_order_page   = Order.PAGE_ORDER;
  this.curr_sett_page    = Order.PAGE_ORDER;

  //this.curr_order_page = this.curr_sett_page;

  this.setState({display_type:Order.DISPLAY_SETTINGS, 
                 evt:bEvt, 
                 book_levels:this.props.oData.book_levels,

                 cancel_at_err: false,

                 order_page: Order.PAGE_ORDER,

                 def_order: this.oDefOrder}); //

  //this.dotRef?.SetIndexForce(this.curr_sett_page);
  this.SlideIn();
  }

  /*   -------------------------------------------------------------------   */

  public ShowChartInfo()
  {
  ModalEx.oModalEx?.Show();
  this.setState({display_type:Order.DISPLAY_CHART_INFO});
  //this.SlideIn();
  }

  /*   -------------------------------------------------------------------   */

  public ShowNoOrder(sText                                        = "Trading not available",
                     sTextStyle: StyleProp<TextStyle> | undefined = undefined)
  {
  ModalEx.oModalEx?.Show();
  this.setState({display_type:Order.DISPLAY_NO_ORDER,
                 display_txt:sText,
                 display_txt_style:sTextStyle});
  //this.SlideIn();
  }

  /*   -------------------------------------------------------------------   */

  public ShowCxtStatus()
  {
  ModalEx.oModalEx?.Show();
  this.setState({display_type:Order.DISPLAY_CXT_STATUS});
  //this.SlideIn();
  }

  /*   -------------------------------------------------------------------   */

  ChangeAccount(sAccKey : string)
  {
  //alert(sAccId + "/" + this.state.pos_data?.acc_id);

  if (sAccKey != this.state.pos_data?.acc_key)
    {
    this.setState({pos_data: this.GetData(sAccKey)});
    
    this.props.oData.sv_account = sAccKey;
    //this.forceUpdate();
    }
  }

  /*   -------------------------------------------------------------------   */

  ChangeAccountForce(oData : PosData)
  {
  //alert(sAccId + "/" + this.state.pos_data?.acc_id);

  if (oData.acc_key != this.state.pos_data?.acc_key ||
      oData.token   != this.state.pos_data?.token)
    {
    this.setState({pos_data: oData});
    //this.forceUpdate();
    }
  }

  /*   -------------------------------------------------------------------   */

  state      : OrderState; 
  oDefOrder  : OrdDefault | undefined;
  oCurrOrder : OrdDefault;
  oSett      : Settings | undefined;

  /*   -------------------------------------------------------------------   */


                    // = {visible:false,
                    //     buy_conf:false, sell_conf:false,
                    //     buy_conf_org:false, sell_conf_org:false,
                    //     //conf_visible:false, sym_prop_visible:false, 
                        
                    //     display_type:Order.DISPLAY_TRADE_BAR,
                    //     display_txt:"",

                    //     book_levels:100,

                    //     pnl_type:Order.PNL_AUTO,
                    //     wo_type:Order.WO_COUNT,
                    //     confirm_actions:true,

                    //     qty:1, def_qty:1, def_qty_evt:1, evt:false,
                    //     cancel_all_enabled:false, flatten_enabled:false, reverse_enabled:false,
                    //     price_type:PriceType.MARKET,
                    //     AnimOp: new Animated.Value(0),
                      
                    //     order_page: Order.PAGE_ORDER,

                    //     def_order: new OrdDefault(),
                    //     curr_order: new OrdDefault(),
                    //     // cancel_after_sec: 1,
                      
                    //     // cancel_at_hr: 0,
                    //     // cancel_at_min: 0,
                    //     // cancel_at_sec: 0,
                    //     // cancel_at_type: Order.REL_MIN,

                    //     // bracket_target_tks:1,
                    //     // bracket_stop_tks:1,
                    //     };

  /*   ---------------------------------------------------------------------   */

  SetDefaults(bCreateDef : boolean = false, 
              bSetCurr   : boolean = true)
  {
    if (!this.oDefOrder)
      {
      let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
      let oSett : ISettings | undefined;

      /*   ---------------------------------------------------------------   */
      
      if (z != AppMain.IMAGINARY)
        {
        oSett = ConnectionOrd.oSettings[z];

        if (oSett?.oOrdDefaults)
          this.oDefOrder = ConnectionOrd.CopyOrdDefault(oSett.oOrdDefaults,
                                                        new OrdDefault);
        }
      }

    /*   -----------------------------------------------------------------   */

    if (!this.oDefOrder && bCreateDef)
      {
      this.oDefOrder = new OrdDefault();  
      }

    /*   -----------------------------------------------------------------   */      

    if (bSetCurr)
      {
      let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
      let oSett : ISettings | undefined;
  
      if (z != AppMain.IMAGINARY)
        {
        oSett = ConnectionOrd.oSettings[z];

        this.oCurrOrder = ConnectionOrd.GetCurrFromCurrent(oSett.oOrdCurrent, 
                                                           new OrdDefault());
        ConnectionOrd.GetCurrFromDefault(this.oDefOrder, this.oCurrOrder);
        }
      else
        this.oCurrOrder = ConnectionOrd.GetCurrFromDefault(this.oDefOrder, 
                                                           new OrdDefault());
      }

    // let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
    // let oSett : ISettings | undefined;

    // /*   -----------------------------------------------------------------   */
    
    // if (z != AppMain.IMAGINARY)
    //   {
    //   oSett = ConnectionOrd.oSettings[z];
    //   }

    // /*   -----------------------------------------------------------------   */

    // if (oSett?.oOrdDefaults)
    //   this.oDefOrder = Order.CopyOrdDefault(oSett.oOrdDefaults,
    //                                         new OrdDefault);

    // this.oCurrOrder = Order.GetCurrFromDefault(this.oDefOrder, 
    //                                            new OrdDefault());
  }

  /*   ---------------------------------------------------------------------   */

  ShowOrderConf(bBuyConf    : boolean,
                iPriceType  : number              = PriceType.MARKET,
                dPrice      : number  | undefined = undefined,
                sWindowName : string)
  {
  if (Connection.IsOrderAvailable() == false)
    {
    this.ShowNoOrder();  
    return(false);
    }

  /*   -------------------------------------------------------------------   */

  this.SetDefaults(false, true);

  /*   -------------------------------------------------------------------   */

  this.curr_order_page   = Order.PAGE_ORDER;
  this.curr_sett_page    = Order.PAGE_ORDER;

  //this.dotRef?.SetIndex(Order.PAGE_ORDER);

  /*   -------------------------------------------------------------------   */

  if (this.state.confirm_actions == false)
    {
    if (!this.validateOrder(this.oCurrOrder, true, false, true))
      {
      return;
      
      ModalEx.oModalEx?.Show();

      this.iPriceType = iPriceType;
      
      this.setState({
                    //conf_visible:true,
                    //sym_prop_visible:false,
                    display_type: Order.DISPLAY_TRADE_BAR_CONF,

                    qty: this.state.def_qty,

                    buy_conf: bBuyConf,
                    buy_conf_org: bBuyConf,

                    sell_conf: !bBuyConf,
                    sell_conf_org: !bBuyConf,

                    price_type: iPriceType,
                    price: dPrice,

                    cancel_at_err: true,

                    def_order: this.oDefOrder,
                    curr_order: this.oCurrOrder,
                    //  cancel_after_en:false,
                    //  cancel_at_en:false,

                    order_page: Order.PAGE_OPTIONS,
                    });

      return(true);
      }

    if (this.state.pos_data)
      {
      // ConnectionOrd.oConn?.
      // Rq_PlaceOrder(this.state.pos_data?.acc_key,
      //               this.props.oData.token,
      //               bBuyConf? TransactionType.BUY : TransactionType.SELL,
      //               this.state.def_qty,
      //               iPriceType,
      //               dPrice);
      ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                          this.props.oData.token,
                                          bBuyConf? TransactionType.BUY : TransactionType.SELL,
                                          this.state.def_qty,
                                          sWindowName,
                                          iPriceType,
                                          dPrice,
                                          this.oCurrOrder.cancel_after_en? 
                                          this.oCurrOrder.cancel_after_sec : undefined,
                                          this.oCurrOrder.cancel_at_en? 
                                          this.cancelAtTime : undefined,
                                          
                                          this.oCurrOrder.bracket_target_en? 
                                          this.oCurrOrder.bracket_target_tks : undefined,
                                          this.oCurrOrder.bracket_stop_en? 
                                          this.oCurrOrder.bracket_stop_tks : undefined,
                                          (this.oCurrOrder.bracket_target_en || 
                                          this.oCurrOrder.bracket_stop_en)? 
                                          this.oCurrOrder.bracket_stop_trl : undefined
                                          );

      return(false);
      }
    }

  ModalEx.oModalEx?.Show();

  this.iPriceType = iPriceType;

  this.setState({
                 //conf_visible:true,
                 //sym_prop_visible:false,
                 display_type: Order.DISPLAY_TRADE_BAR_CONF,

                 qty: this.state.def_qty,

                 buy_conf: bBuyConf,
                 buy_conf_org: bBuyConf,

                 sell_conf: !bBuyConf,
                 sell_conf_org: !bBuyConf,

                 price_type: iPriceType,
                 price: dPrice,

                 cancel_at_err: false,

                 def_order: this.oDefOrder,
                 curr_order: this.oCurrOrder,

                 order_page: Order.PAGE_ORDER,

                 window_name: sWindowName,
                //  cancel_after_en:false,
                //  cancel_at_en:false,

                 });
  //this.SlideIn();
  return(true);
  }

  /*   ---------------------------------------------------------------------   */

  ShowSellConf(sWindowName : string,
               iPriceType  : number             = PriceType.MARKET,
               dPrice      : number | undefined = undefined)
  {
  if (this.ShowOrderConf(false, iPriceType, dPrice, sWindowName))
    this.SlideIn()

  return;

  if (Connection.IsOrderAvailable() == false)
    {
    this.ShowNoOrder();  
    return;
    }

  /*   -------------------------------------------------------------------   */

  this.SetDefaults();

  /*   -------------------------------------------------------------------   */

  if (this.state.confirm_actions == false)
    {
    if (this.state.pos_data)
      {
      ConnectionOrd.oConn?.
      Rq_PlaceOrder(this.state.pos_data?.acc_key,
                    this.props.oData.token,
                    TransactionType.SELL,
                    this.state.def_qty,
                    "",
                    iPriceType,
                    dPrice);

      return;
      }
    }

  ModalEx.oModalEx?.Show();

  this.iPriceType = iPriceType;

  this.setState({
                 //conf_visible:true,
                 //sym_prop_visible:false,
                 display_type:Order.DISPLAY_TRADE_BAR_CONF,

                 qty:this.state.def_qty,

                 buy_conf:false,
                 buy_conf_org:false,

                 sell_conf:true,
                 sell_conf_org:true,

                 price_type:iPriceType,
                 price:dPrice,

                 cancel_at_err: false,

                 def_order: this.oDefOrder,
                 curr_order: this.oCurrOrder,
                //  cancel_after_en:false,
                //  cancel_at_en:false,

                 });
  this.SlideIn();
  }

  /*   ---------------------------------------------------------------------   */

  ShowBuyConf(sWindowName : string,
              iPriceType  : number             = PriceType.MARKET,
              dPrice      : number | undefined = undefined
              )
  {
  if (this.ShowOrderConf(true, iPriceType, dPrice, sWindowName))
    this.SlideIn();

  return;

  if (Connection.IsOrderAvailable() == false)
    {
    this.ShowNoOrder();  
    return;
    }

  if (this.state.confirm_actions == false)
    {
    if (this.state.pos_data)
      {
      ConnectionOrd.oConn?.
      Rq_PlaceOrder(this.state.pos_data?.acc_key,
                    this.props.oData.token,
                    TransactionType.BUY,
                    this.state.def_qty,
                    "",
                    iPriceType,
                    dPrice);

      return;
      }
    }

  ModalEx.oModalEx?.Show();

  this.iPriceType = iPriceType;

  this.setState({
                 //conf_visible:true,
                 //sym_prop_visible:false,
                 display_type:Order.DISPLAY_TRADE_BAR_CONF,

                 qty:this.state.def_qty,

                 buy_conf:true,
                 buy_conf_org:true,

                 sell_conf:false,
                 sell_conf_org:false,

                 price_type:iPriceType,
                 price:dPrice,
                
                 cancel_at_err: false,

                 def_order: this.oDefOrder,
                 curr_order: this.oCurrOrder,
                 });
  this.SlideIn();
  }

  /*   ---------------------------------------------------------------------   */

  GetCurrency()
  {
    switch(this.oAccData?.currency)
      {
      default:
        return("dollar");
      case "EUR":
        return("euro");
      case "JPY":
        return("yen");
      case "GBP":
        return("pound");
      }
  }

  /*   ---------------------------------------------------------------------   */

  GetPNLColor(bGray : boolean = false)
  {
  switch(this.state.pnl_type)
    {
    case Order.PNL_AUTO:  
      
      if (this.state.pos_data?.net_qty != undefined &&
          this.state.pos_data?.net_qty != 0)
        {
        if (this.state.pos_data?.open_pnl == undefined)
          return(bGray? 'gray' : 'gainsboro');
        else if (this.state.pos_data?.open_pnl >= 0)
          return(FontInfo.sGreen);
        else //if (this.state.pos_data?.open_pnl < 0)
          return('red');
        // else
        //   return(bGray? 'gray' : 'gainsboro');          
        }
      else
        {
        if (this.state.pos_data?.total_pnl     == undefined ||
            (this.state.pos_data?.total_pnl == 0 && 
             this.state.pos_data?.net_qty   == 0)
            // !this.state.pos_data?.total_pnl
            )
            return(bGray? 'gray' : 'gainsboro');
        else if (this.state.pos_data?.total_pnl >= 0)
          return(FontInfo.sGreen);
        else //if (this.state.pos_data?.total_pnl < 0)
          return('red');
        // else
        //   return(bGray? 'gray' : 'gainsboro');
        }
      
    case Order.PNL_OPEN:
        if (this.state.pos_data?.open_pnl     == undefined ||
            // !this.state.pos_data?.open_pnl                 ||
            (this.state.pos_data?.open_pnl == 0 && 
              this.state.pos_data?.net_qty == 0))
            return(bGray? 'gray' : 'gainsboro');
        else if (this.state.pos_data?.open_pnl >= 0)
          return(FontInfo.sGreen);
        else // if (this.state.pos_data?.open_pnl < 0)
          return('red');
        // else
        //   return(bGray? 'gray' : 'gainsboro');

    case Order.PNL_TOTAL:
        if (this.state.pos_data?.total_pnl     == undefined ||
            // !this.state.pos_data?.total_pnl
            (this.state.pos_data?.total_pnl == 0 && 
             this.state.pos_data?.net_qty   == 0)
            )
            return(bGray? 'gray' : 'gainsboro');
        else if (this.state.pos_data?.total_pnl >= 0)
          return(FontInfo.sGreen);
        else //if (this.state.pos_data?.total_pnl < 0)
          return('red');
        // else
        //   return(bGray? 'gray' : 'gainsboro');
          
    case Order.PNL_OFF:
      return(bGray? 'gray' : 'gainsboro');
    }
  }

  /*   ---------------------------------------------------------------------   */

  GetPosColor()
  {
    if (this.state.pos_data?.net_qty == undefined ||
        this.state.pos_data?.net_qty == 0)
      return('gainsboro')
    else if (this.state.pos_data?.net_qty > 0)
      return('dodgerblue')
    else
      return('hotpink')
  }

  /*   ---------------------------------------------------------------------   */

  GetOrdColor()
  {
  //if (this.state.wo_type == Order.WO_QTY)
    {
    if (this.state.pos_data                       == undefined ||
        this.state.pos_data.orders_working        == undefined ||
        this.state.pos_data.orders_working.length == 0)
      return('gainsboro');
    else if (this.state.pos_data.order_buy_qty && !this.state.pos_data?.order_sell_qty)
      return('dodgerblue');
    else if (!this.state.pos_data.order_buy_qty && this.state.pos_data?.order_sell_qty)
      return('hotpink');
    else
      return('#bc4dff'); //#b233ff //'#9f00ff');
    }
  // else
    // {
    //   if (this.state.pos_data                       == undefined ||
    //       this.state.pos_data.orders_working        == undefined ||
    //       this.state.pos_data.orders_working.length == 0)
    //   return('gainsboro');
    // else
    //   return('darkorange');
    // }
  }

  /*   ---------------------------------------------------------------------   */

  GetOrderText()
  {
  if (this.state.wo_type == Order.WO_QTY)
    {
    if (this.state.pos_data?.net_qty == undefined)
      return ("");
    // else if (this.state.pos_data.order_buy_qty && !this.state.pos_data?.order_sell_qty)
    //   return("" + this.state.pos_data.order_buy_qty + "");
    // else if (!this.state.pos_data.order_buy_qty && this.state.pos_data?.order_sell_qty)
    //   return("" + this.state.pos_data.order_sell_qty + "");
    else
      return(this.state.pos_data.order_buy_qty + "/" + this.state.pos_data.order_sell_qty); //#b233ff //'#9f00ff');
    }
  else
    {
      return( this.state.pos_data?.net_qty == undefined? "" : this.state.pos_data?.orders_working.length.toString() );
    }
  }

  /*   ---------------------------------------------------------------------   */

  GetPNLText()
  {
    switch(this.state.pnl_type)
    {
    case Order.PNL_AUTO:
      if (this.state.pos_data?.net_qty)
        return(this.state.pos_data?.open_pnl);
      else
        return(this.state.pos_data?.total_pnl);

      case Order.PNL_OPEN:
        return(this.state.pos_data?.open_pnl);

      case Order.PNL_TOTAL:
        return(this.state.pos_data?.total_pnl);

      case Order.PNL_OFF:
        return(undefined);
    }
  }

  /*   ---------------------------------------------------------------------   */

  GetPNLTitle()
  {
    switch(this.state.pnl_type)
    {
    case Order.PNL_AUTO:
      if (this.state.pos_data?.net_qty)
        return("P&L (Open)");
      else
        return("P&L (Closed)");

      case Order.PNL_OPEN:
        return("P&L (Open)");

      case Order.PNL_TOTAL:
        return("P&L (Total)");

      case Order.PNL_OFF:
        return("P&L (Off)");
    }
  }

  /*   ---------------------------------------------------------------------   */

  renderBuySellBar()
  {
  // if (this.state.display_type!=Order.DISPLAY_TRADE_BAR)
  //   return(null);
  // else
  return(
  <>
        <TouchableOpacity
            style={[{backgroundColor:'transparent', paddingLeft:20, minHeight:40, alignItems:'center', alignContent:'center', justifyContent:'center'}]}
            onPress={()=>
              {
                this.ShowBuyConf("Quote Board, Buy Button", PriceType.MARKET);
                return;

                ModalEx.oModalEx?.Show();
                // Alert.alert(
                //   "Alert Title",
                //   this.state.pos_data?.token,
                //   [
                //       {
                //       text: "Cancel",
                //       onPress: () => console.log("Cancel Pressed"),
                //       style: "cancel"
                //     },
                //     { text: "OK", onPress: () => console.log("OK Pressed") }
                //   ]
                // );

              //alert("" + this.state.pos_data?.acc_key + " orders: " + this.state.pos_data?.orders.length);

              // this.setState({price_type:PriceType.MARKET, conf_visible:true, sym_prop_visible:false, buy_conf:true, buy_conf_org:true, sell_conf:false, sell_conf_org:false  })
              this.setState({price_type:PriceType.MARKET, display_type:Order.DISPLAY_TRADE_BAR_CONF, buy_conf:true, buy_conf_org:true, sell_conf:false, sell_conf_org:false  })
              // ConnectionOrd.oConn?.PlaceOrder(this.state.pos_data?.acc_id,
              //                                 this.props.data.token,
              //                                 TransactionType.BUY,
              //                                 1)
              }}
          >
        <Text style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', minWidth:Utilities.WIDTH/7, color:'dodgerblue', textAlign:'left', textAlignVertical:'center'}]}>Buy</Text>
        </TouchableOpacity>

        <View style={{minHeight:20, backgroundColor:'transparent', minWidth:160, flexDirection:'row', alignItems:'center', alignContent:'center', justifyContent:'center'}}>

        {/* <FontAwesome5 name="money-bill" size={12} color="green" /> */}
        {/* <FontAwesome5 name="comment-dollar" size={13} color="gainsboro" /> */}
        {/* <Foundation name="dollar" size={12} color="green" /> */}
        <TextWithImage bindEvent={this.props.bindEvent}
              // Sample_Image={()=>{return( <FontAwesome5 name="comment-dollar" size={13} color={this.GetPNLColor()} />)}}
              onPress={()=>{this.ShowSettings(false)}}
              Sample_Image={()=>{return(<Foundation name={this.GetCurrency()} size={18} color={this.GetPNLColor()} />)}}
              getStyle={()=>
                {
                  return([FontInfo.appStyles.txt_bold, {color: this.GetPNLColor(), }])
                //   if (this.state.pos_data?.net_qty != undefined &&
                //       this.state.pos_data?.net_qty != 0)
                //     {
                //     if (this.state.pos_data?.open_pnl == undefined)
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'gainsboro', }])
                //     else if (this.state.pos_data?.open_pnl >= 0)
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'green', }])
                //     else
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'red', }])
                //     }
                // else
                //     {
                //     if (this.state.pos_data?.closed_pnl == undefined)
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'gainsboro',}])
                //     else if (this.state.pos_data?.closed_pnl >= 0)
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'green', }])
                //     else
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'red',}])
                //     }
                }}
              getText={()=>{return(this.GetPNLText())}}
                // ()=>
                // {
                //   switch(this.state.pnl_type)
                //     {
                //     case Order.PNL_AUTO:
                //       if (this.state.pos_data?.net_qty)
                //         return(this.state.pos_data?.open_pnl);
                //       else
                //         return(this.state.pos_data?.closed_pnl);

                //       case Order.PNL_OPEN:
                //         return(this.state.pos_data?.open_pnl);

                //       case Order.PNL_TOTAL:
                //         return(this.state.pos_data?.total_pnl);

                //       case Order.PNL_OFF:
                //         return(undefined);
                //     }
                // }}
                />

                   {/* if (this.state.pos_data?.net_qty)
                     return(this.state.pos_data?.open_pnl? "$" + this.state.pos_data?.open_pnl : "$");
                   else
                     return(this.state.pos_data?.closed_pnl? "$" + this.state.pos_data?.closed_pnl : "$"); */}


             {/* <FontAwesome5 style={{marginLeft:8, marginTop:-2}} name="shopping-bag" size={12} color="gainsboro" /> */}
             {/* <MaterialCommunityIcons name="shopping-outline" size={12} color="green" /> */}
             <TextWithImage bindEvent={this.props.bindEvent}
              onPress={this.ShowSymbolProps}
              Sample_Image={()=>{return(<FontAwesome5 style={{marginLeft:6, marginTop:-2}} name="shopping-bag" size={12} color={this.GetPosColor()} />)}}
              getStyle={()=>
                {
                  return([FontInfo.appStyles.txt_bold, {color: this.GetPosColor() }])

                  // if (this.state.pos_data?.net_qty == undefined ||
                  //     this.state.pos_data?.net_qty == 0)
                  //   return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'gainsboro' }])
                  // else if (this.state.pos_data?.net_qty > 0)
                  //   return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'dodgerblue' }])
                  // else
                  //   return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'hotpink' }])
                }}
              getText={()=>
                {
                  if (this.state.pos_data?.net_qty ||
                      this.state.pos_data?.closed_pnl)
                    return("" + this.state.pos_data?.net_qty + "");
                  else
                    return("");
                }} />



        {/* <FontAwesome5 name="shopping-basket" size={12} color="green" /> */}
        {/* <Feather style={{marginLeft:4}} name="shopping-cart" size={12} color="gainsboro" /> */}
        {/* <OBChange
            bindEvent={this.props.bindEvent}
            getStyle={()=>{ return(this.state.pos_data?.net_qty == undefined? {display:'none'} : this.state.pos_data?.orders_working.length > 0? {borderRadius:5, marginLeft:4, backgroundColor:'green'} : {borderRadius:5, marginLeft:4, backgroundColor:'gainsboro'} //{borderRadius:5, marginLeft:4, backgroundColor:'green'} : {borderRadius:5, marginLeft:4, backgroundColor:'gray'}
                                  )}}
            style={{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color:'white',}}
            getText={()=>{return( this.state.pos_data?.net_qty == undefined? "" : this.state.pos_data?.orders_working.length.toString() )}}
            /> */}

         <TextWithImage bindEvent={this.props.bindEvent}
            onPress={this.ShowSymbolProps}
            Sample_Image={()=>{return(<Feather style={{marginLeft:4}} name="shopping-cart" size={12} color={this.GetOrdColor()} />)}}
            getStyle={()=>{ return(
              this.state.pos_data?.net_qty == undefined? {display:'none'} : [FontInfo.appStyles.txt_bold, {color:this.GetOrdColor()}]
              
              // this.state.pos_data?.orders_working.length > 0?
              //   {fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color:'green'} :
              //   {fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color:'gainsboro'} //{borderRadius:5, marginLeft:4, backgroundColor:'green'} : {borderRadius:5, marginLeft:4, backgroundColor:'gray'}
              )}}
            getText={()=>{return( this.GetOrderText() )}}
            />

        </View>

        {/* <View style={{minHeight:20, backgroundColor:'transparent', alignItems:'center', alignContent:'center', justifyContent:'center'}}>
        <OBNakedStaticStyleText
            bindEvent={this.props.bindEvent}
            style={{fontSize:12, fontWeight:'bold', color:'white', borderRadius:5, backgroundColor:'gray'}}
            getText={()=>{return( this.state.pos_data? this.state.pos_data.orders_working.length.toString() : "?" )}}
            />
        </View> */}

        <TouchableOpacity
            style={[{backgroundColor:'transparent', paddingRight:20, minHeight:40, alignItems:'center', alignContent:'center', justifyContent:'center'}]}
            onPress={()=>
              {
                this.ShowSellConf("Quote Board, Sell Button", PriceType.MARKET);
                return;

                ModalEx.oModalEx?.Show();

                // this.setState({price_type:PriceType.MARKET, conf_visible:true, sym_prop_visible:false, buy_conf:false, buy_conf_org:false, sell_conf:true, sell_conf_org:true})
                this.setState({price_type:PriceType.MARKET, display_type:Order.DISPLAY_TRADE_BAR_CONF, buy_conf:false, buy_conf_org:false, sell_conf:true, sell_conf_org:true})
                // ConnectionOrd.oConn?.PlaceOrder(this.state.pos_data?.acc_id,
                //   this.props.data.token,
                //   TransactionType.SELL,
                //   1)
              }}
          >
        <Text style={[FontInfo.appStyles.txt_bold, {minWidth:Utilities.WIDTH/7, color:'hotpink', textAlign:'right'}]}>Sell</Text>
        </TouchableOpacity>
  </>
  );    
  }

  /*   ---------------------------------------------------------------------   */

  render()
   {
    return(
      <View style={Connection.IsLoggedIn() == false? {display: "none"} : {alignSelf:'center', flexDirection:'row', backgroundColor:'transparent', marginTop:0, marginBottom:-10, }}>
        {/* <Text style={{fontSize:12}}>Hi</Text> */}

        <this.renderOrderConf/>  
        <this.renderSymbolProps/>
        <this.renderSettings/>
        {/* <this.renderChartInfo/> */}
        <this.renderNoOrder/>
        <this.renderBuySellBar/>
        </View>

      );

   }
}

/*   =====================================================================   */

function GetPickerStylesDate()
{
return(

  StyleSheet.create({
    inputWeb: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
      //paddingLeft: 40,
  
      // marginLeft:5,
      //width:200,
      //marginVertical:20,

      //paddingLeft: 40,
      marginTop:5,
      height:40,
      minWidth:100,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 1,
      // borderColor: '#EEEEEE',
      // borderRadius: 4,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      //paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    inputIOS: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
  
  
      //marginVertical:20,
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal: FontInfo.iFontSize + 2,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
    inputAndroid: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      // alignSelf:'center',
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      // paddingLeft: 20,
      //paddingVertical: 12,
      //paddingLeft: 30,
  
      //marginVertical:20,
  
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 0,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
      // textAlign:'center',
      // borderWidth: 0.5,
      // borderColor: 'purple',
      // borderRadius: 8,
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    // button_order:
    // {
    //   backgroundColor:'#f5f6fa',
    //   margin:10,
    //   padding:8,
    //   borderRadius:10,
    //   minWidth:90,
    // },
  
    // text_order:
    // {
    // alignSelf:'center',
    // fontWeight:'bold',
    // color:'red'
    // },
  
  })  

);  
}

/*   =====================================================================   */

function GetPickerStyles()
{
return(

  StyleSheet.create({
    inputWeb: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
      //paddingLeft: 40,
  
      // marginLeft:5,
      //width:200,
      //marginVertical:20,
      paddingLeft: 40,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 1,
      // borderColor: '#EEEEEE',
      // borderRadius: 4,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    inputIOS: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
  
  
      //marginVertical:20,
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal: FontInfo.iFontSize + 2,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
    inputAndroid: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      // alignSelf:'center',
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      // paddingLeft: 20,
      //paddingVertical: 12,
      //paddingLeft: 30,
  
      //marginVertical:20,
  
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 0,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
      // textAlign:'center',
      // borderWidth: 0.5,
      // borderColor: 'purple',
      // borderRadius: 8,
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    // button_order:
    // {
    //   backgroundColor:'#f5f6fa',
    //   margin:10,
    //   padding:8,
    //   borderRadius:10,
    //   minWidth:90,
    // },
  
    // text_order:
    // {
    // alignSelf:'center',
    // fontWeight:'bold',
    // color:'red'
    // },
  
  })  

);  
}

// const pickerSelectStyles = StyleSheet.create({
//   inputWeb: {
//     fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
//     fontSize: FontInfo.iFontSize + 2,
//     fontWeight:'bold',
//     //paddingVertical: 12,
//     //paddingLeft: 40,

//     // marginLeft:5,
//     //width:200,
//     //marginVertical:20,
//     paddingLeft: 40,
//     marginTop:10,
//     height:40,
//     width:272,
//     textAlign:'center',

//     marginHorizontal:14,
//     marginBottom:8,
//     borderWidth: 1,
//     borderColor: 'gainsboro',
//     borderRadius: 10,

//     // borderWidth: 1,
//     // borderColor: '#EEEEEE',
//     // borderRadius: 4,
//     // borderBottomWidth:0,
//     // borderBottomColor:'#EEEEEE',
//     // borderBottomEndRadius:0,
//     // borderBottomStartRadius:0,


//     backgroundColor:'transparent',
//     color: FontInfo.sForeground,

//     paddingRight: 30, // to ensure the text is never behind the icon
//   },

//   inputIOS: {
//     fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
//     fontSize: FontInfo.iFontSize + 2,
//     fontWeight:'bold',
//     //paddingVertical: 12,


//     //marginVertical:20,
//     // marginLeft:5,
//     paddingLeft: 30,
//     marginTop:10,
//     height:40,
//     width:272,
//     textAlign:'center',

//     marginHorizontal: FontInfo.iFontSize + 2,
//     marginBottom:8,
//     borderWidth: 1,
//     borderColor: 'gainsboro',
//     borderRadius: 10,
//     // borderBottomWidth:0,
//     // borderBottomColor:'#EEEEEE',
//     // borderBottomEndRadius:0,
//     // borderBottomStartRadius:0,

//     backgroundColor:'transparent',
//     color: FontInfo.sForeground,
//     paddingRight: 30, // to ensure the text is never behind the icon
//   },
//   inputAndroid: {
//     fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
//     // alignSelf:'center',
//     fontSize: FontInfo.iFontSize,
//     fontWeight:'bold',
//     // paddingLeft: 20,
//     //paddingVertical: 12,
//     //paddingLeft: 30,

//     //marginVertical:20,

//     // marginLeft:5,
//     paddingLeft: 30,
//     marginTop:10,
//     height:40,
//     width:272,
//     textAlign:'center',

//     marginHorizontal:14,
//     marginBottom:8,
//     borderWidth: 1,
//     borderColor: 'gainsboro',
//     borderRadius: 10,

//     // borderWidth: 0,
//     // borderBottomWidth:0,
//     // borderBottomColor:'#EEEEEE',
//     // borderBottomEndRadius:0,
//     // borderBottomStartRadius:0,
//     // textAlign:'center',
//     // borderWidth: 0.5,
//     // borderColor: 'purple',
//     // borderRadius: 8,

//     backgroundColor:'transparent',
//     color: FontInfo.sForeground,
//     paddingRight: 30, // to ensure the text is never behind the icon
//   },

//   // button_order:
//   // {
//   //   backgroundColor:'#f5f6fa',
//   //   margin:10,
//   //   padding:8,
//   //   borderRadius:10,
//   //   minWidth:90,
//   // },

//   // text_order:
//   // {
//   // alignSelf:'center',
//   // fontWeight:'bold',
//   // color:'red'
//   // },

// });

const styles = StyleSheet.create({
row_header_container: {
  height:25,
  flexDirection:'row',
  display:'flex',
  // alignSelf: 'stretch',
  justifyContent: 'center',
  fontWeight: 'bold',
  backgroundColor: 'rgba(0,0,0,.9)',//'#04cd25', //'black',//"lightslategrey",

  //borderWidth: 1,
  borderTopRightRadius: 20,
  borderTopLeftRadius: 20,
},

row_header: {
  alignSelf: 'center',
  //fontSize: FontInfo.iFontSize + 2,
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
},
});
